import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { environment } from "../../../environments/environment";
import { DatePipe } from "@angular/common";
import { appService } from "../../_services/app.service";
import { ToastrService } from "ngx-toastr";
import { elementAt } from "rxjs/operators";
import { CommonService } from "../../../app/_services/common.service";
import { NavService } from "../../_services/NavService.service";
import { TimelineService } from "../../_services/timeline.service";
import { CookieService } from "ngx-cookie-service";
import { Helpers } from "../../helpers";
import { DebugContext } from "@angular/core/src/view";
import { DocumentsComponent } from "../../../app/documentshared/documents.component";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { NetworkComponent } from "../../../app/Network/network/network.component";
import { TranslateService } from "@ngx-translate/core";
import { DecryptPipe } from "../../auth/_services/encrypt-decrypt.pipe";
import { Router } from "@angular/router";
import { type } from "@amcharts/amcharts4/core";
import { Console } from "@angular/core/src/console";
import { error } from "jquery";
declare var jquery: any;
declare var $: any;
declare var moment: any;
const LNG_KEY = "SELECTED_LANGUAGE";
@Component({
  selector: "app-bills",
  templateUrl: "./bills.component.html",
})
export class BillsComponent implements OnInit, AfterViewInit {

  Expensebytrip: any = [];
  isGSTNo: boolean = false;
  ConsignmentId: any;
  isDebit: boolean = false;
  static bc: BillsComponent;
  selectedLang: string;
  ShowVendorDetails: boolean = false;
  showbill: boolean = false;
  IsNewCase: boolean = false;
  TenantId: any;
  CompanyId: any;
  UserId: any;
  hostUrl: any = environment.apiUrl;
  GstMasterWithComponent: any = [];
  GSTMasterList: any = [];
  TDSMasterList: any = [];
  DashboardData: any = {};
  isIntra: any;
  // LoginCompanyState: any;-
  //NetTotalArr: any = [];
  // NetTotalObj: any = {};
  Bills: any = {};
  Checkchargefortrip: any = {};
  ChargesList: any = [];
  ChargeObj: any = {};
  amountArr: any = [];
  CGSTList: any = [];
  SGSTList: any = [];
  IGSTList: any = [];
  Financialyear: any
  IsPaymentRequestBill: any = false;
  isAnotherComponent: any = false;

  CGSTAmount: any;
  SGSTAmount: any;
  IGSTAmount: any;
  SubTotal: any;

  SelectedCompanyGSTCode: any;

  IsAuthorized: any = false;
  IsPosted: any = false;

  ReferenceId: any;
  ReferenceType: any;
  billsComponent: any;
  // static billsComponent: BillsComponent;
  datatableBills;

  selectedCard: string = "Draft";
  JVSummaryData: any = [];
  PaymentSummaryData: any = [];
  datatableForPendingBill: any;
  //Advance Payment
  BalanceAdvanceAmount: any = 0;
  BalanceTDS: any = 0;
  AdvancePaymentDetailList: any = [];
  //Advance Payment-Pop up
  TotalAdvanceLeft: any = 0;
  TotalTDSLeft: any = 0;
  TotalAppliedAdvance: any = 0;
  TotalAppliedTDS: any = 0;
  BalanceBillAmount: any = 0;
  BalanceTDSAmount: any = 0;
  NetPayableBillAmount: any = 0;
  BillAmountWithTax: any = 0;
  AppliedAdvance = 0;
  AppliedAdvanceTDS = 0;
  NetAppliedAdvance: any = 0;
  NetAppliedAdvanceTDS: any = 0;
  TDSMain: any = 0;

  ShowAttachment: any = false;
  //add kevin 28/09/2020
  isInternational: boolean = false;
  //end
  //add siddharth 25/06/2021
  AuditTrailData: any = [];
  //end

  //add vithujan 10-08-2022
  TaxApplicableFlag: boolean = false;
  //end
  //added by vithujan 10-01-2023
  contextmenu: any = false;
  contextmenuX: any = 0;
  contextmenuY: any = 0;
  //end
  //added by vithujan 25-01-2023
  FinancialYearArray: any = [];
  //end
  //added by vithujan 06-02-02023
  TransactionType: any = "";
  ModalType: any = "";
  rowIndex = -1;
  totalRowsCount: any = 0;
  //end
  //added by vithujan 14-03-2023
  IntraState: any = [];
  OutSideyourState: any = [];
  AccountData: any = {};
  model: any = {};
  GetChargeTypeList: any = [];
  GetChargeMethodList: any;
  GetTransportMethodList: any = [];
  //end
  isShowOtherModel: any = "NO";
  postBillListData: any = [];
  //added by vithujan 02-06-2023
  isISAUrl: any =
    environment.apiUrl == "https://isa.ifreightbox.net/" ? true : false;
  chargeWiseTDSMasterList: any = [];
  isEdit: any = false;
  grandTotal: any = 0;
  TotalOfBalanceDue: any = 0;
  SelectedCompanyLogo: any;
  SelectedCompanyLogoImg: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyPAN: any;
  PrintBillData: any = [];

  //currentBillList: any[] = []
  //grandTotal: any = 0;
  //TotalOfBalanceDue: any = 0;

  @ViewChild(NetworkComponent) ChildNetworkComponent: NetworkComponent;
  @ViewChild(DocumentsComponent) AttachmentChild: DocumentsComponent;
  IsPushedtoERP: boolean = false;
  isRRUrl: any = environment.apiUrl == "https://tms.rrkabel.com/" ? true : false;
  constructor(
    private datePipe: DatePipe,
    private _appService: appService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private _navService: NavService,
    private cookieService: CookieService,
    private service1: TranslateConfigService,
    private translate: TranslateService,
    private service: TimelineService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) {
    this.billsComponent = this;
    BillsComponent.bc = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service1.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {

    //added by maaria
    if (localStorage.getItem("fromPayment") == "true") {
      this.GetBillById(localStorage.getItem("SelectedBillId"));
      setTimeout(() => {
        localStorage.removeItem("fromPayment");
        //localStorage.removeItem("SelectedBillId");
      }, 200);
    }
    //end
    //add kevin 28/09/2020
    this.isInternational = JSON.parse(localStorage.getItem("SalesFlag"));
    //end
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.SelectedCompanyGSTCode = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).GSTCode;
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this.SelectedComapnyName = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompantGSTIN;
    this.SelectedCompanyPAN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyPAN;
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;

    this.GetAccountingYear();
    this.ClearDashBoardData();
    this.GetBillsList();

    this.RefreshParentDropdown();
    this.GetVendorName();
    this.GetFuelPumpList();
    this.GetGstList();
    this.GetTDSList();
    this.GstMasterWithComponentList();
    //add vithujan 10-08-2022
    this.LoadTaxApplicable();
    //end
    //added by vithujan 14-03-2023
    this.GetSelectData();
    //end
    this.GetTDSListForCharge();

    // this.GetBillNo();
    // this.SearchStatus('Draft');
    // $("#Charges").change(function () {
    //     that.billsComponent.ChargeDataGet();
    // });
    $("#btnSaveForBill").prop("disabled", false);
    $("#btnAuthorizedForBill").prop("disabled", true);
    $("#btnPostForBill").prop("disabled", true);
    // added by vithujan 06-02-2023
    this.showHelpMenu();
    //end
    //added by vithujan 08-02-2024 - Siddarth
    this.GetSelectBillNo();

    setTimeout(() => {
      this._navService.navItem$.subscribe((item) => {
        this.ClearDashBoardData();
        this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
        this.datatableBills.destroy();
        this.GetBillsList();
        this.GetGstList();
        // this.SearchStatus('Draft');
      });
    }, 500);
  }

  onSend(billno, ref) {
    if (billno !== undefined && ref !== undefined) {
      this.service.show = true;
      this.service.shareType = billno;
      this.service.ref = ref;
      this.service.sendFrom = "bills";
    } else {
      alert("Please Select Bill No");
    }
  }
  ngAfterViewInit() {
    this.GetDueDate();
    this.RefreshvalidDate();
    $(".datepicker2").datepicker({ format: "dd/mm/yyyy" });

    $(".datepicker3").datepicker({
      format: "dd-M-yyyy",
      orientation: "bottom",
      autoclose: true,
    });
    BillsComponent.bc.RefreshvalidDateModal();

    $("#AdvancePayment").on("hidden.bs.modal", function () {
      this.ClearAdvancePaymentDataData();
    });
    const that = this;
    $("#BillsAttchment").on("shown.bs.modal", function () {
      that.billsComponent.OnAttachmentClick();
    });

    //added by vtihujan 25-01-2023
    $("#SalesInvoiceAdvanceSearch").on("shown.bs.modal", function () {
      BillsComponent.bc.GetBillListByCompany();
      BillsComponent.bc.GetCustomerVendorSelect2Data();
      BillsComponent.bc.GetContainerList();
      BillsComponent.bc.GetTripNoList();
      BillsComponent.bc.GetAccountingYear();
    });
    //end
  }

  FilterBillOnType(type) {
    if (type == "Debit") {
      this.isDebit = true;
      this.NewBill();
    } else {
      this.isDebit = false;
      this.NewBill();
    }
  }

  DecideInterIntra(state) {
    this._appService
      .GetInterOrIntra("Bills", "GetInterOrIntra", state, this.CompanyId)
      .subscribe(
        (response) => {
          BillsComponent.bc.isIntra = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  NewBill() {
    this.showbill = true;
    this.IsNewCase = true;
    this.Bills = {};
    if (this.IsPaymentRequestBill) {
      this.Bills.ChargeType = "Account";
    } else {
      this.Bills.ChargeType = "Charge";
    }
    this.ChargesList = [];
    this.ChargeObj = {};
    this.IsAuthorized = false;
    this.IsPosted = false;
    this.ShowAttachment = false;
    this.IsPushedtoERP = false;
    this.ClearData();
    this.ClearValidations();
    this.RefreshParentDropdown();
    $("#btnSaveForBill").prop("disabled", false);
    $("#btnAuthorizedForBill").prop("disabled", true);
    $("#btnPostForBill").prop("disabled", true);
    if (this.commonService.CheckHasRight("ADD", "BILLS_DETAILS")) {
      $("#btnSaveForBill").css("display", "inline-block");
    } else {
      $("#btnSaveForBill").css("display", "none");
    }
    //added by vithujan 23-02-2023
    setTimeout(() => {
      document.getElementById("VendorName").focus();
    }, 100);
    //end
  }

  onBack() {
    this.showbill = false;
    this.datatableBills.destroy();
    this.GetBillsList();
    $("#BillDate").val("");
    $("#BillRefDate").val("");
    $("#DueDate").val("");
    this.amountArr = [];
    this.CGSTList = [];
    this.SGSTList = [];
    this.IGSTList = [];
    this.ChargesList = [];
    this.IsAuthorized = false;
    this.IsPosted = false;
    this.IsPushedtoERP = false;
    this.grandTotal = 0;
    this.TotalOfBalanceDue = 0;

    if ($("#VendorName").select2()) {
      $("#VendorName").val("");
      $("#VendorName").select2("destroy");
    }
    if ($("#THC").select2()) {
      $("#THC").val("");
      $("#THC").select2("destroy");
    }
    if ($("#Charges").select2()) {
      $("#Charges").val("");
      $("#Charges").select2("destroy");
    }
    if ($("#TripExpenseCharge").select2()) {
      $("#TripExpenseCharge").val("");
      $("#TripExpenseCharge").select2("destroy");
    }
    $("#FuelPump").val("");
    this.GetVendorName();
    this.GetFuelPumpList();
    this.SearchStatus(this.selectedCard);

    $("#btnShowPaymentDetails").addClass("fa-plus");
    $("#btnShowPaymentDetails").removeClass("fa-minus");
    $("#ShowBillPaymentDetails").css("display", "none");
    this.PaymentSummaryData = [];

    $("#btnShowBillJVDetails").addClass("fa-plus");
    $("#btnShowBillJVDetails").removeClass("fa-minus");
    $("#ShowJVBillDetails").css("display", "none");
    $("#btnShowAuditTrail_bill").addClass("fa-plus");
    $("#btnShowAuditTrail_bill").removeClass("fa-minus");
    $("#ShowAuditTrail_bill").css("display", "none");
    this.JVSummaryData = [];

    //Advance Payment
    this.BalanceAdvanceAmount = 0;
    this.BalanceTDS = 0;
    this.AdvancePaymentDetailList = [];
    //Advance Payment-Pop up
    this.TotalAdvanceLeft = 0;
    this.TotalTDSLeft = 0;
    this.TotalAppliedAdvance = 0;
    this.TotalAppliedTDS = 0;
    this.BalanceBillAmount = 0;
    this.BalanceTDSAmount = 0;
    this.NetPayableBillAmount = 0;
    this.BillAmountWithTax = 0;
    this.AppliedAdvance = 0;
    this.AppliedAdvanceTDS = 0;
    this.NetAppliedAdvance = 0;
    this.NetAppliedAdvanceTDS = 0;
  }

  GetGstList() {
    this._appService
      .GetById("Bills", "GetGstList", this.CompanyId)
      .subscribe((Response) => {
        this.GSTMasterList = Response;
        this.RefreshParentDropdown();
      });
  }

  GetTDSList() {
    this._appService.Get("Bills", "GetTDSList").subscribe((Response) => {
      this.TDSMasterList = Response;
      this.RefreshParentDropdown();
    });
  }

  AddCharge() {

    this.Expensebytrip = [];
    this.ConsignmentId = '';

    this.ClearValidationsForCharges();
    var Flag = this.Validations();
    if (Flag) {
      this.ChargeObj = {};
      this.ClearAddChargeData();
      $("#BillModel").modal("show");
      window.scrollTo(0, 0);
      //added by vithujan 27-05-2023 
      setTimeout(() => {
        document.getElementById("THC").focus();
      }, 500);
      //end
      if (
        this.Bills.ChargeType != "Account" &&
        this.Bills.ChargeType != "RepairsAndMaintenance"
      ) {
        if (this.Bills.TaxPreference == "No") {
          $("#GSTMaster").val("NA");
          $("#GSTMaster").attr("disabled", true);
        }
      } else {
        $("#GSTMaster").val("NA");
        $("#GSTMaster").attr("disabled", false);
      }
    } else {
      this.toastr.error("Please Select Required Data !", "Error");
    }
  }

  ClearAddChargeData() {
    // this.Bills.HSNNo = '';
    // this.Bills.GstMaster = '';
    // this.Bills.BasedOn = '';
    this.ChargeObj.Quantity = 0;
    this.ChargeObj.Rate = 0;
    this.ChargeObj.Discount = 0;
    this.ChargeObj.Amount = 0;
    this.ChargeObj.VehicleNo = "";
    this.ChargeObj.VehicleDispatchDate = "";
    this.ChargeObj = {};
    this.ChargeObj.TranspoterId = this.billsComponent.Bills.VendorId;
    this.ChargeObj.TDS = this.Bills.TDS;
    $("#HSNNo").val("");
    $("#GSTMaster").val("");
    $("#BasedOn").val("");
    $("#Qty").val("");
    $("#Rate").val("");
    $("#Discount").val("");
    this.RefreshParentDropdown();
    if ($("#Charges").select2()) {
      $("#Charges").val("");
      $("#Charges").select2("destroy");
    }
    if ($("#THC").select2()) {
      $("#THC").val("");
      $("#THC").select2("destroy");
    }
    if ($("#selectVehicleNo").select2()) {
      $("#selectVehicleNo").val("");
      $("#selectVehicleNo").select2("destroy");
    }
    if ($("#selectTyreNo").select2()) {
      $("#selectTyreNo").val("");
      $("#selectTyreNo").select2("destroy");
    }
    this.GetVendorName();
  }

  GstMasterWithComponentList() {
    this._appService
      .Get("Bills", "GstMasterWithComponent")
      .subscribe((Response) => {
        this.GstMasterWithComponent = Response;
      });
  }

  RefreshParentDropdown() {
    setTimeout(function () {
      (<any>$("#ChargeType")).selectpicker("refresh");
      (<any>$("#BasedOn")).selectpicker("refresh");
      (<any>$("#Type")).selectpicker("refresh");
      (<any>$("#GSTMaster")).selectpicker("refresh");
      (<any>$("#TDS")).selectpicker("refresh");
      (<any>$("#se_bh_chTDS")).selectpicker("refresh");
    }, 200);
  }

  RefreshvalidDate() {
    setTimeout(() => {
      $(".datepicker1").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }

  GetDueDate() {
    $("#BillDate,#PaymentTerms").change(function () {
      var DueDate = moment($("#BillDate").val(), "DD-MM-YYYY").add(
        $("#PaymentTerms").val(),
        "days"
      );
      $("#DueDate").datepicker("setDate", new Date(DueDate));
    });
  }

  GetVendorName() {
    const that = this;
    $("#VendorName").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetVendorName",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#VendorName").text("");
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: that.billsComponent.TenantId,
            Type: "Bills",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [","],

      placeholder: "Search for Vendor",
    });

    $("#VendorName").on("select2:select", function (e) {
      var data = e.params.data;
      console.log(data.id);

      // that.billsComponent.Bills = $.extend({}, data, {});
      that.billsComponent.ShowVendorDetails = true;
      that.billsComponent.Bills.Address = data.Address;
      that.billsComponent.Bills.City = data.City;
      that.billsComponent.Bills.State = data.State;
      that.billsComponent.Bills.Country = data.Country;
      that.billsComponent.Bills.PostalCode = data.PostalCode;
      that.billsComponent.Bills.PaymentTerms = data.PaymentTerms;
      that.billsComponent.Bills.Type = data.Type;
      that.billsComponent.Bills.GSTNo = data.GSTNo;
      that.billsComponent.Bills.TranspoterId = data.TranspoterId;
      that.billsComponent.Bills.TaxPreference = data.TaxPreference;
      that.billsComponent.Bills.ExemptionReasons = data.ExemptionReasons;
      that.billsComponent.Bills.TDSPreference = data.TDSPreference;
      that.billsComponent.Bills.GSTNo = data.GSTNo;
      that.billsComponent.Bills.TDS = data.TDS;
      that.billsComponent.Bills.IsReverseChargeApplicable =
        data.IsReverseChargeApplicable;
      that.billsComponent.RefreshParentDropdown();

      $("#BillDate").val(data.BillDate);
      $("#BillDate").datepicker("setDate", new Date());

      var DueDate = moment($("#BillDate").val(), "DD-MM-YYYY").add(
        data.PaymentTerms,
        "days"
      );
      $("#DueDate").datepicker("setDate", new Date(DueDate));
      that.billsComponent.Bills.TranspoterId = data.TranspoterId;

      if (that.billsComponent.ChargeObj == undefined) {
        that.billsComponent.ChargeObj = {};
        that.billsComponent.ChargeObj.Transpoter = data.text;
        that.billsComponent.ChargeObj.TranspoterId = data.id;
      } else {
        that.billsComponent.ChargeObj.Transpoter = data.text;
        that.billsComponent.ChargeObj.TranspoterId = data.id;
      }
      that.billsComponent.Bills.VendorId = data.id;

      //added by maaria
      that.DecideInterIntra(that.billsComponent.Bills.GSTNo);
      that.billsComponent.GetBalancedAdvance(data.id);
      that.billsComponent.GetAdvancePaymentDetailById(data.id);

      //added by maaria  on 07-11-2023
      //
      if (data.TaxPreference == "Yes") {
        if (data.GSTNo != null && data.GSTNo != undefined && data.GSTNo != "") {
          that.billsComponent.isGSTNo = true;
          $("#btnSaveForBill").prop("disabled", false);
        } else {
          that.billsComponent.isGSTNo = false;
          $("#btnSaveForBill").prop("disabled", true);
          that.billsComponent.toastr.error(
            "Kindly enter GST No. in Network Master to enable Save button !",
            "Error"
          );
        }
      } else {
        $("#btnSaveForBill").prop("disabled", false);
      }
      //end
      that.billsComponent.get_IsCompanyDisable(data.id)
    });

    $("#THC").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetThcNo",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TranspoterId: that.billsComponent.Bills.TranspoterId,
            Type: that.billsComponent.Bills.Type,
            GetType: "GetOpen",
          };
        },
        processResults: function (data, params) {
          if (data.Results.length > 0) {
            that.billsComponent.Bills.THC = data.Results[0].id;
            that.billsComponent.Bills.VehicleNo = data.Results[0].VehicleNo;
            that.billsComponent.Bills.VehicleSize = data.Results[0].VehicleSize;
            that.billsComponent.Bills.PaidWeight = data.Results[0].PaidWeight;

            if (that.billsComponent.Bills.ChargeType == "Account") {
              that.billsComponent.Bills.TotalQuantity = 0;
            } else {
              that.billsComponent.Bills.TotalQuantity =
                data.Results[0].TotalQuantity;
            }
          }
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for THC",
    });

    $("#THC").on("select2:select", function (e) {
      var data = e.params.data;
      that.billsComponent.ChargeObj.THC = data.id;
      that.billsComponent.ConsignmentId = data.id;
      that.billsComponent.ChargeObj.THCName = data.ConsignmentNo;
      // that.billsComponent.ChargeObj.THCName = data.text;

      that.billsComponent.ChargeObj.VehicleNo = data.VehicleNo;
      that.billsComponent.ChargeObj.VehicleDispatchDate =
        data.VehicleDispatchDate;
      that.billsComponent.Bills.VehicleNo = data.VehicleNo;
      that.billsComponent.Bills.PaidWeight = data.PaidWeight;
      that.billsComponent.Bills.VehicleSize = data.VehicleSize;
      that.billsComponent.Bills.ShortageQuantity = data.ShortageQuantity;
      if (that.billsComponent.Bills.ChargeType == "Account") {
        that.billsComponent.Bills.Quantity = 0;
      } else {
        that.billsComponent.Bills.Quantity = data.TotalQuantity;
      }
    });

    $("#Charges").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetChargeForAccouting",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            ChargeType: $("#ChargeType").val(),
            GSTType:
              that.billsComponent.Bills.GSTNo ==
                that.billsComponent.SelectedCompanyGSTCode
                ? "Intra"
                : "Inter",
            TransporterId: that.billsComponent.Bills.VendorId,
            THCId: $("#THC").val(),
          };
        },
        processResults: function (data, params) {
          // that.billsComponent.Bills.ChargeId = data.Results[0].id;
          // that.billsComponent.Bills.ChargeName = data.Results[0].text;
          // that.billsComponent.Bills.HSNNo = data.Results[0].HSNNo;
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 20 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Search for Charges",
    });

    $("#Charges").on("select2:select", function (e) {
      //
      var data = e.params.data;

      if (BillsComponent.bc.ChargeObj == undefined) {
        BillsComponent.bc.ChargeObj = {};
        BillsComponent.bc.ChargeObj.ChargeName = data.text;
        BillsComponent.bc.ChargeObj.ChargeId = data.id;
        BillsComponent.bc.ChargeObj.ChargeAccount = data.text;
      } else {
        BillsComponent.bc.ChargeObj.ChargeName = data.text;
        BillsComponent.bc.ChargeObj.ChargeAccount = data.text;
        BillsComponent.bc.ChargeObj.ChargeId = data.id;
        BillsComponent.bc.ChargeObj.HSNNo = data.HSNNo;
      }
      BillsComponent.bc.Bills.ChargeId = data.id;
      BillsComponent.bc.Bills.ChargeName = data.text;
      BillsComponent.bc.Bills.HSNNo = data.HSNNo;
      BillsComponent.bc.Bills.IsGSTApplicable = data.IsGSTApplicable;
      BillsComponent.bc.ChargeObj.Rate = data.UnitRate;
      // BillsComponent.bc.ChargeDataGet();
      if (
        BillsComponent.bc.Bills.ChargeType != "Account" &&
        BillsComponent.bc.Bills.ChargeType != "RepairsAndMaintenance"
      ) {
        if (BillsComponent.bc.Bills.TaxPreference == "Yes") {
          if (data.IsGSTApplicable) {
            $("#GSTMaster").val("NA");
            $("#GSTMaster").attr("disabled", false);
            $("#GSTMaster").val(data.GSTId);
          } else {
            $("#GSTMaster").val("NA");
            $("#GSTMaster").attr("disabled", true);
          }
        } else {
          $("#GSTMaster").val("NA");
          $("#GSTMaster").attr("disabled", true);
        }
      } else {
        $("#GSTMaster").val("NA");
        $("#GSTMaster").attr("disabled", false);
      }
      //added by maaria on 06-11-2023
      BillsComponent.bc._appService
        .GetByFourId(
          "Bills",
          "GetGSTIfApplicable",
          BillsComponent.bc.isIntra,
          e.params.data.id,
          $("#VendorName").val(),
          BillsComponent.bc.CompanyId
        )
        .subscribe(
          (response) => {
            if (response.length > 0) {
              if (response[0] != 0) {
                $("#GSTMaster").val(response[0].Id);
                $("#GSTMaster").attr("disabled", false);
              }
            }
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          }
        );
      //end

      // BillsComponent.bc.ChargeObj.TDS = null;
      // BillsComponent.bc.chargeWiseTDSMasterList.forEach(element => {
      //   if (data.TDS == element.id) {
      //     BillsComponent.bc.ChargeObj.TDS = element.id;
      //   }
      // });
      BillsComponent.bc.RefreshParentDropdown();
    });

    // add kevin 08-Mar-2022
    $("#selectVehicleNo").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/bill_getVehicleNoList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            param: BillsComponent.bc.CompanyId,
            param1: BillsComponent.bc.Bills.TranspoterId,
            param2: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Vehicle No",
    });

    $("#selectVehicleNo").on("select2:select", function (e) {
      var data = e.params.data;
      that.billsComponent.ChargeObj.VehicleId = data.id;
      that.billsComponent.ChargeObj.VehicleNo = data.text;
    });

    $("#selectTyreNo").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/bill_getTyreNoList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            param: BillsComponent.bc.CompanyId,
            param1:
              BillsComponent.bc.ChargeObj.VehicleId == undefined
                ? null
                : BillsComponent.bc.ChargeObj.VehicleId,
            param2: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Tyre",
    });

    $("#selectTyreNo").on("select2:select", function (e) {
      var data = e.params.data;
      that.billsComponent.ChargeObj.TyreId = data.id;
      that.billsComponent.ChargeObj.TyreNo = data.text;
    });
    // end
  }

  GetFuelPumpList() {
    const that = this;
    $("#FuelPump").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/BookingOrigin/GetFuelPumpList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            param1: params.term,
            param2: that.billsComponent.CompanyId,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Fuel Pump",
    });
  }

  DateChange() {
    $("#BillDate,#PaymentTerms").change(function () {
      var DueDate = moment($("#BillDate").val(), "DD-MM-YYYY").add(
        $("#PaymentTerms").val(),
        "days"
      );
      $("#DueDate").datepicker("setDate", new Date(DueDate));
    });
  }

  PopChangeData() {
    if (
      this.ChargeObj.Discount == "undefined" ||
      this.ChargeObj.Discount == null
    ) {
      this.ChargeObj.Discount = 0;
    } else {
      this.ChargeObj.Discount = parseFloat(this.ChargeObj.Discount.toFixed(2));
    }

    if (this.ChargeObj.Rate == "undefined" || this.ChargeObj.Rate == null) {
      this.ChargeObj.Rate = 0;
    } else {
      this.ChargeObj.Rate = parseFloat(this.ChargeObj.Rate.toFixed(2));
    }

    if (
      this.ChargeObj.Quantity == "undefined" ||
      this.ChargeObj.Quantity == null
    ) {
      this.ChargeObj.Quantity = 0;
    } else {
      this.ChargeObj.Quantity = parseFloat(
        parseFloat(this.ChargeObj.Quantity).toFixed(2)
      );
    }

    this.ChargeObj.Amount =
      this.ChargeObj.Rate * this.ChargeObj.Quantity - this.ChargeObj.Discount;
    this.ChargeObj.Amount = parseFloat(this.ChargeObj.Amount.toFixed(2));

    if (this.ChargeObj.TDS != null) {
      var TDSRateIn = this.chargeWiseTDSMasterList.find(
        (x) => x.id == this.ChargeObj.TDS
      ).RateIn;
      this.ChargeObj.TDSAmount = parseFloat(
        ((this.ChargeObj.Amount * TDSRateIn) / 100).toFixed(2)
      );
    } else {
      this.ChargeObj.TDSAmount = 0;
    }
  }

  AddChargeInList() {

    var Flag = this.ValidationsForCharges();

    if (Flag) {

      this._appService.GetByTwoId('Sales', 'Checkchargefortrip', this.ChargeObj.THC, this.ChargeObj.ChargeName).subscribe(
        (response) => {
          this.Checkchargefortrip = response;
          console.log(this.ChargesList, "this is ChargesList");
          console.log(this.Checkchargefortrip.TripNo, 'check charge trip no ');
          console.log(this.Checkchargefortrip.ChargeAccount, 'check charge account');

          if (this.Checkchargefortrip && Object.keys(this.Checkchargefortrip).length > 0) {
            this.toastr.error(
              "The Bill for the same THC No and Charge Code already exists"
            );
            return;
          }


          for (let i = 0; i < this.ChargesList.length; i++) {
            if (this.ChargesList[i].THCName === this.Checkchargefortrip.TripNo &&
              this.ChargesList[i].ChargeName === this.Checkchargefortrip.ChargeAccount) {
              this.toastr.error("The Bill for the same THC No and Charge Code already exists");
              return;
            }
          }

          // Only add charges if the previous checks do not match
          if (this.ChargeObj.Id == null) {
            this.ChargeObj.GSTMasterId = $("#GSTMaster").val();
            this.ChargeObj.GstMaster = $("#GSTMaster option:selected").text().trim();
            this.ChargeObj.Amount = this.ChargeObj.Amount;
            this.ChargeObj.Id = this.ChargesList.length + 1;

            // Added by Vithujan 23-06-2023
            this.ChargeObj.TDSName = $("#se_bh_chTDS option:selected").text().trim();
            // End

            this.ChargesList.push(this.ChargeObj);
            this.calcGST();
            console.log(this.ChargesList);
          } else {
            if ($("#GSTMaster").val() == "NA") {
              this.ChargeObj.GSTMasterId = null;
            } else {
              this.ChargeObj.GSTMasterId = $("#GSTMaster").val();
            }
            this.ChargeObj.GstMaster = $("#GSTMaster option:selected").text().trim();
            this.ChargeObj.Amount = this.ChargeObj.Amount;

            // Added by Vithujan 23-06-2023
            this.ChargeObj.TDSName = $("#se_bh_chTDS option:selected").text().trim();
            // End

            this.calcGST();
          }

          // Added by Vithujan 02-06-2023
          if (this.isISAUrl == true) {
            this.AutoSetOffAdvance();
          }
          $("#BillModel").modal("hide");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    } else {
      this.toastr.error("Please Fill Required Details !", "Error");
    }
  }

  calcGST() {
    this.CGSTAmount = 0;
    this.SGSTAmount = 0;
    this.IGSTAmount = 0;
    this.SubTotal = 0;
    var CGST = this.GstMasterWithComponent.find(
      (x) => x.Id == this.ChargeObj.GstMasterId && x.TaxComponent == "CGST"
    );
    var SGST = this.GstMasterWithComponent.find(
      (x) => x.Id == this.ChargeObj.GstMasterId && x.TaxComponent == "SGST"
    );
    var IGST = this.GstMasterWithComponent.find(
      (x) => x.Id == this.ChargeObj.GstMasterId && x.TaxComponent == "IGST"
    );

    this.ChargesList.forEach((element) => {
      CGST = this.GstMasterWithComponent.find(
        (x) => x.Id == element.GSTMasterId && x.TaxComponent == "CGST"
      );
      SGST = this.GstMasterWithComponent.find(
        (x) => x.Id == element.GSTMasterId && x.TaxComponent == "SGST"
      );
      IGST = this.GstMasterWithComponent.find(
        (x) => x.Id == element.GSTMasterId && x.TaxComponent == "IGST"
      );
      this.SubTotal = parseFloat(this.SubTotal) + parseFloat(element.Amount);
      this.SubTotal = parseFloat(this.SubTotal.toFixed(2));

      if (CGST != undefined || CGST != null) {
        this.Bills.CGSTPer = CGST.TaxRates;
        this.Bills.CGSTVal = element.Amount * (this.Bills.CGSTPer / 100);
        this.Bills.CGSTVal = element.CGSTAmount = parseFloat(
          this.Bills.CGSTVal.toFixed(2)
        );
        this.CGSTAmount = this.CGSTAmount + this.Bills.CGSTVal;
        this.CGSTAmount = parseFloat(this.CGSTAmount.toFixed(2));
      }

      if (SGST != undefined || SGST != null) {
        this.Bills.SGSTPer = SGST.TaxRates;
        this.Bills.SGSTVal = element.Amount * (this.Bills.SGSTPer / 100);
        this.Bills.SGSTVal = element.SGSTAmount = parseFloat(
          this.Bills.SGSTVal.toFixed(2)
        );
        this.SGSTAmount = this.SGSTAmount + this.Bills.SGSTVal;
        this.SGSTAmount = parseFloat(this.SGSTAmount.toFixed(2));
      }

      if (IGST != undefined || IGST != null) {
        this.Bills.IGSTPer = IGST.TaxRates;
        this.Bills.IGSTVal = element.Amount * (this.Bills.IGSTPer / 100);
        this.Bills.IGSTVal = element.IGSTAmount = parseFloat(
          this.Bills.IGSTVal.toFixed(2)
        );
        this.IGSTAmount = this.IGSTAmount + this.Bills.IGSTVal;
        this.IGSTAmount = parseFloat(this.IGSTAmount.toFixed(2));
      }

      //add vithujan 10-08-2022
      if (this.TaxApplicableFlag == true) {
        if (this.Bills.IsReverseChargeApplicable == true) {
          this.Bills.NetTotal = this.SubTotal;
        } else {
          this.Bills.NetTotal =
            this.SubTotal + this.CGSTAmount + this.SGSTAmount + this.IGSTAmount;
        }
      } else {
        this.Bills.NetTotal = this.SubTotal;
        this.CGSTAmount = 0;
        this.SGSTAmount = 0;
        this.IGSTAmount = 0;
      }
      this.Bills.NetTotal = parseFloat(this.Bills.NetTotal.toFixed(2));
    });
    this.TDSChange();
  }

  TDSChange() {
    // if (
    //   this.Bills.TDS != null &&
    //   this.Bills.TDS != undefined &&
    //   this.Bills.TDS != ""
    // ) {
    this.TDSMain = 0;
    this.ChargesList.forEach((element) => {
      this.TDSMain = this.TDSMain + element.TDSAmount;
    });
    this.TDSMain = parseFloat(this.TDSMain.toFixed(2));
    this.Bills.TDSRates = this.TDSMain;
    // var TDSRateIn = this.TDSMasterList.find((x) => x.Id == this.Bills.TDS).RateIn;
    // this.TDSMain = (this.SubTotal * TDSRateIn) / 100;
    // this.Bills.TDSRates = (this.SubTotal * TDSRateIn) / 100;
    this.Bills.AppliedAdvanceTDS =
      this.Bills.AppliedAdvanceTDS == undefined
        ? 0
        : this.Bills.AppliedAdvanceTDS;
    this.Bills.TDSRates -= this.Bills.AppliedAdvanceTDS;
    this.Bills.TDSRates = parseFloat(this.Bills.TDSRates.toFixed(2));
    this.Bills.NetTotal = this.Bills.NetTotal - this.Bills.TDSRates;
    this.Bills.NetTotal = parseFloat(this.Bills.NetTotal.toFixed(2));
    // }
    this.CalculateNetAmountForAdvance();
  }

  SaveBills() {
    Helpers.setLoading(true);
    if (this.Bills.NetTotal != 0) {
      // this.Bills.BillDate = $('#BillDate').data('datepicker').getFormattedDate('yyyy-MM-dd');
      var Flag = this.Validations();
      if (Flag) {
        this.Bills.ReferenceType = this.ReferenceType;
        this.Bills.ReferenceId = this.ReferenceId;

        this.Bills.BillDate = this.GetFormattedDate(
          "BillDate",
          this.Bills.BillDate
        );
        this.Bills.ReferenceDate = this.GetFormattedDate(
          "BillRefDate",
          this.Bills.ReferenceDate
        );
        this.Bills.DueDate = this.GetFormattedDate(
          "DueDate",
          this.Bills.DueDate
        );

        this.Bills.VendorGSTNo = this.Bills.GSTNo;
        this.Bills.Town = this.Bills.City;

        // this.Bills.DueDate = $('#DueDate').data('datepicker').getFormattedDate('yyyy-MM-dd');
        this.Bills.GSTStateCode = this.Bills.GSTNo;
        this.Bills.SGSTAmount = this.SGSTAmount;
        this.Bills.CGSTAmount = this.CGSTAmount;
        this.Bills.IGSTAmount = this.IGSTAmount;
        this.Bills.TDSAmount = this.Bills.TDSRates;

        this.Bills.AppliedAdvance = this.AppliedAdvance;
        this.Bills.AppliedAdvanceTDS = this.AppliedAdvanceTDS;

        this.Bills.PaymentTermsRemark = $("#PaymentTermsRemark").val();
        this.Bills.TdsId = $("#TDS").val();
        //added by vithujan 08-02-2024 - Siddarth
        this.Bills.BillRefId = $("#BillNoSelect").val();
        //end

        if (this.Bills.Type == "Transpoter") {
          this.Bills.Vendor = $("#VendorName").val();
          this.Bills.DriverId = null;
        }
        if (this.Bills.Type == "Driver") {
          this.Bills.DriverId = $("#VendorName").val();
          this.Bills.Vendor = null;
        }
        this.Bills.FulePumpId = $("#FuelPump").val();

        this.Bills.TaxApplicable = this.Bills.TaxPreference;
        this.Bills.CompanyId = this.CompanyId;
        this.Bills.Remark = $("#Remarks").val();
        // var button_text = document.getElementById('Save').innerHTML;
        // this.Bills.Status = button_text;
        this.Bills.SubTotal = this.SubTotal;
        this.Bills.BillDetails = [];
        this.Bills.BillDetails = this.ChargesList;
        if (this.Bills.IsPaymentRequestBill) {
          this.Bills.IsPaymentRequest = true;
        } else {
          this.Bills.IsPaymentRequest = false;
        }

        var BillDetailsConsignmentwiseArray = [];
        // var TDSRateIn = this.TDSMasterList.find((x) => x.Id == this.Bills.TDS).RateIn;
        for (var k = 0; k < this.ChargesList.length; k++) {
          if (BillDetailsConsignmentwiseArray.length == 0) {
            var tempOBJ: any = {};
            tempOBJ.BillsHeaderId = null;
            tempOBJ.THC = null;
            if (this.Bills.IsReverseChargeApplicable == true) {
              tempOBJ.TotalAmount =
                this.ChargesList[k].Amount - this.ChargesList[k].TDSAmount;
            } else {
              tempOBJ.TotalAmount =
                this.ChargesList[k].Amount +
                (this.ChargesList[k].CGSTAmount == undefined ||
                  this.ChargesList[k].CGSTAmount == null
                  ? 0
                  : this.ChargesList[k].CGSTAmount) +
                (this.ChargesList[k].SGSTAmount == undefined ||
                  this.ChargesList[k].SGSTAmount == null
                  ? 0
                  : this.ChargesList[k].SGSTAmount) +
                (this.ChargesList[k].IGSTAmount == undefined ||
                  this.ChargesList[k].IGSTAmount == null
                  ? 0
                  : this.ChargesList[k].IGSTAmount) -
                this.ChargesList[k].TDSAmount;
            }
            tempOBJ.PaidAmount = this.Bills.AppliedAdvance;
            // tempOBJ.TotalTDS = (this.ChargesList[k].Amount * TDSRateIn) / 100;
            tempOBJ.TotalTDS = this.ChargesList[k].TDSAmount;
            tempOBJ.PaidTDS = this.Bills.AppliedAdvanceTDS;
            BillDetailsConsignmentwiseArray.push(tempOBJ);
          } else {
            if (this.Bills.IsReverseChargeApplicable == true) {
              BillDetailsConsignmentwiseArray[0].TotalAmount =
                BillDetailsConsignmentwiseArray[0].TotalAmount +
                (this.ChargesList[k].Amount - this.ChargesList[k].TDSAmount);
            } else {
              BillDetailsConsignmentwiseArray[0].TotalAmount =
                BillDetailsConsignmentwiseArray[0].TotalAmount +
                (this.ChargesList[k].Amount +
                  (this.ChargesList[k].CGSTAmount == undefined ||
                    this.ChargesList[k].CGSTAmount == null
                    ? 0
                    : this.ChargesList[k].CGSTAmount) +
                  (this.ChargesList[k].SGSTAmount == undefined ||
                    this.ChargesList[k].SGSTAmount == null
                    ? 0
                    : this.ChargesList[k].SGSTAmount) +
                  (this.ChargesList[k].IGSTAmount == undefined ||
                    this.ChargesList[k].IGSTAmount == null
                    ? 0
                    : this.ChargesList[k].IGSTAmount) -
                  this.ChargesList[k].TDSAmount);
            }
            // BillDetailsConsignmentwiseArray[0].TotalTDS = BillDetailsConsignmentwiseArray[0].TotalTDS + (this.ChargesList[k].Amount * TDSRateIn) / 100;
            BillDetailsConsignmentwiseArray[0].TotalTDS =
              BillDetailsConsignmentwiseArray[0].TotalTDS +
              this.ChargesList[k].TDSAmount;
          }
        }
        this.Bills.BillDetailsConsignmentwise = [];
        this.Bills.BillDetailsConsignmentwise = BillDetailsConsignmentwiseArray;
        this.Bills.THC = null;

        //add by maaria on 19-10-2023
        this.Bills.isDebit = this.isDebit;
        //end
        if (this.ChargesList.length > 0) {
          this._appService.Post("Bills", "SaveBills", this.Bills).subscribe(
            (response) => {
              this.Bills.Id = response;
              this.ShowAttachment = true;
              $("#btnSaveForBill").prop("disabled", false);
              $("#btnAuthorizedForBill").prop("disabled", false);
              $("#btnPostForBill").prop("disabled", true);
              this.SavePaymentDetail();
              // this.CheckRereferenceNo(this.Bills.Id);
              setTimeout(() => {
                this.onBack();
                this.GetBillById(this.Bills.Id);
              }, 500);
              Helpers.setLoading(false);
              this.toastr.success("Bill Details Saved Successfully ", "Bills");
              // this.onBack();
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error(err._body.replace(/"/g, ""), "Error");
              // this.toastr.error(
              //   "An Error occured while saving bill data !",
              //   "Error"
              // );
            }
          );
        } else {
          Helpers.setLoading(false);
          this.toastr.error("Please Select any Charge/Account !", "Error");
        }
      } else {
        Helpers.setLoading(false);
        this.toastr.error("Error occurred while saving data !", "Error");
      }
    } else {
      Helpers.setLoading(false);
      this.toastr.error("Zero amount bill is not allowed to Post !", "Error");
    }
  }

  GetBillsList() {
    this.grandTotal = 0;
    this.TotalOfBalanceDue = 0;
    this.GetBillcount();
    // this._appService
    //   .GetByTwoId("Bills", "GetBillStatusCount", this.CompanyId, this.Financialyear)
    //   .subscribe(
    //     (response) => {
    //       this.DashboardData.DraftCount = response[0].DraftCount;
    //       this.DashboardData.AuthorizedCount = response[0].AuthorizedCount;
    //       this.DashboardData.PostedCount = response[0].PostedCount;
    //       this.DashboardData.PendingPaymentsCount =
    //         response[0].PendingPaymentsCount;
    //       this.DashboardData.PaidCount = response[0].PaidCount;
    //       this.DashboardData.DeletedCount = response[0].DeletedCount;
    //       this.DashboardData.AllCount = response[0].AllCount;
    //     },
    //     (err) => { }
    //   );
    const that = this;
    this.datatableBills = (<any>$("#m_datatable_BillList")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Bills/GetBillNoList",
            params: {
              // custom parameters
              CompanyId: that.billsComponent.CompanyId,
              //added by vithujan 25-01-2023
              BillId:
                $("#SelectBillList").val().join(",") == ""
                  ? null
                  : $("#SelectBillList").val().join(","),
              VendorId:
                $("#CompanyData").val().join(",") == ""
                  ? null
                  : $("#CompanyData").val().join(","),
              FromDate:
                BillsComponent.bc.GetFormattedDate(
                  "InvoiceFromDate",
                  $("#InvoiceFromDate").val()
                ) == ""
                  ? null
                  : BillsComponent.bc.GetFormattedDate(
                    "InvoiceFromDate",
                    $("#InvoiceFromDate").val()
                  ),
              ToDate:
                BillsComponent.bc.GetFormattedDate(
                  "InvoiceToDate",
                  $("#InvoiceToDate").val()
                ) == ""
                  ? null
                  : BillsComponent.bc.GetFormattedDate(
                    "InvoiceToDate",
                    $("#InvoiceToDate").val()
                  ),
              Financialyear:
                $("#id_ddlFinancialyear").val() == ""
                  ? null
                  : $("#id_ddlFinancialyear").val(),
              tripId:
                $("#SelectTripNo").val().join(",") == ""
                  ? null
                  : $("#SelectTripNo").val().join(","),
              containerNo:
                $("#SelectContainerList").val().join(",") == ""
                  ? null
                  : $("#SelectContainerList").val().join(","),
            },
            map: function (raw) {
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                // this.currentBillList = raw.data;
                // console.log(this.currentBillList);
                dataSet = raw.data;
                BillsComponent.bc.grandTotal = 0;
                BillsComponent.bc.TotalOfBalanceDue = 0;
                dataSet.forEach((element) => {
                  BillsComponent.bc.grandTotal = parseFloat(
                    (BillsComponent.bc.grandTotal + element.Amount).toFixed(2)
                  );
                  BillsComponent.bc.TotalOfBalanceDue = parseFloat(
                    (
                      BillsComponent.bc.TotalOfBalanceDue + element.BalanceDue
                    ).toFixed(2)
                  );
                });
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
        //serverSorting: !0
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100, 500, 1000],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#BillSearch"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          let flag = 0;
          if (flag == 0) {
            // that.billsComponent.DashboardData.DraftCount = data.DraftCount;
            // that.billsComponent.DashboardData.AuthorizedCount = data.AuthorizedCount;
            // that.billsComponent.DashboardData.PostedCount = data.PostedCount;
            // that.billsComponent.DashboardData.PendingPaymentsCount = data.PendingPaymentsCount;
            // that.billsComponent.DashboardData.PaidCount = data.PaidCount;
            // that.billsComponent.DashboardData.AllCount = data.AllCount;
            flag = 1;
          }

          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("Id");
              localStorage.setItem("SelectedBillId", Id);
              that.GetBillById(Id);
            });
          $(row)
            .find(".btnDelete")
            .click(function () {
              var Id = $(this).attr("Id");
              that.billsComponent.DeletePurchaseBill(Id);
            });
        },
      },
      columns: [
        {
          field: "Id",
          title: "#",
          sortable: !1,
          width: 20,
          selector: {
            class:
              "m-checkbox m-datatable--on-check m-checkbox--solid m-checkbox--brand BookingIdCheckbox",
          },
          template: function (t) {
            let value = t;
            return value;
          },
        },
        {
          field: "BillNo",
          title: this.selectedLang == "sp" ? "Factura" : "Bill#",
          sortable: false,
          textAlign: "left",
          width: 150,
          template: function (t) {
            if (
              that.billsComponent.commonService.CheckHasRight(
                "VIEW",
                "BILLS_DETAILS"
              )
            ) {
              var btn =
                '<a id="' +
                t.Id +
                '" style="color:#2088d8;font-size:14px;cursor:pointer;"  class="btnEdit" title="Edit details">' +
                t.BillNo +
                "</a>";
            }
            return btn;
          },
        },
        {
          field: "PaymentRequest",
          title:
            this.selectedLang == "sp" ? "Solicitud de pago" : "Payment Request",
          filterable: !1,
          width: 180,
          template: function (t) {
            var res = "";
            if (
              t.PaymentRequest != "" &&
              t.PaymentRequest != undefined &&
              t.PaymentRequest != null
            ) {
              res = `<span class="m-badge m-badge--info m-badge--wide m-badge--roundedr">${t.PaymentRequest}</span><br/>`;
            }
            return res;
          },
        },
        {
          field: "CreatedDate",
          title: this.selectedLang == "sp" ? "Fecha" : "Date",
          filterable: !1,
          width: 100,
        },
        {
          field: "THCNo",
          title:
            this.selectedLang == "sp"
              ? "Cargos de alquiler de camiones"
              : "THC#",
          filterable: !1,
          width: 150,
          responsive: {
            visible:
              this.hostUrl != "http://tms.theptpl.com/" ? "lg" : "hidden",
          },
        },
        {
          field: "ReferenceNo",
          title:
            this.selectedLang == "sp" ? "Numero de referencia" : "Reference No",
          filterable: !1,
          width: 150,
        },
        {
          field: "VendorName",
          title: this.selectedLang == "sp" ? "Vendedor" : "Vendor",
          filterable: !1,
          width: 150,
        },
        {
          field: "Status",
          title: this.selectedLang == "sp" ? "Días de crédito" : "Credit Days",
          filterable: !1,
          width: 120,
          template: function (t) {
            if (t.BalanceDue != 0) {
              if (t.DateDifference >= 0) {
                var btn = `<span class='m--font-bold m--font-success'>Due in ${t.DateDifference} Days</span>`;
              } else {
                var btn = `<span class='m--font-bold m--font-danger'>Over Due By ${t.DateDifference * -1
                  } Days</span>`;
              }
            } else {
              var btn = `<span class='m--font-bold m--font-success'>Paid</span>`;
            }

            return btn;
          },
        },

        {
          field: "DueDate",
          title:
            this.selectedLang == "sp" ? "Fecha de vencimiento" : "Due Date",
          filterable: !1,
          width: 150,
        },

        {
          field: "Amount",
          title: this.selectedLang == "sp" ? "Importe" : "Amount",
          filterable: !1,
          width: 150,
        },
        {
          field: "BalanceDue",
          title: this.selectedLang == "sp" ? "Saldo adeudado" : "Balance Due",
          filterable: !1,
          width: 120,
        },
        {
          field: "Actions",
          width: 110,
          title: this.selectedLang == "sp" ? "Acciones" : "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            if (
              that.billsComponent.commonService.CheckHasRight(
                "VIEW",
                "BILLS_DETAILS"
              )
            ) {
              btn +=
                '<a id="' +
                t.Id +
                '" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details">\t\t\t\t\t\t\t<i class="la la-edit"></i>\t\t\t\t\t\t</a>\t\t\t\t\t\t';
            }
            //added by maaria
            if (
              that.billsComponent.commonService.CheckHasRight(
                "DELETE",
                "BILLS_DETAILS"
              ) &&
              that.billsComponent.selectedCard != "Deleted"
            ) {
              btn +=
                '<a id="' +
                t.Id +
                '" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">\t\t\t\t\t\t\t<i class="la la-trash"></i>\t\t\t\t\t\t</a>\t\t\t\t\t';
            }
            return btn;
          },
        },
      ],
    });
    $("#PurchaseBillDraft").css("border", "#2088d8 1px solid");
    this.datatableBills.search(this.selectedCard, "Status");
    BillsComponent.bc.grandTotal = 0;
    BillsComponent.bc.TotalOfBalanceDue = 0;

    //added by vithujan 20-02-2023
    setTimeout(() => {
      var rows = BillsComponent.bc.datatableBills;
      rows.rows(".m-datatable__row");
      BillsComponent.bc.totalRowsCount = rows.nodes().length;
      BillsComponent.bc.rowIndex = -1;
    }, 2000);
    //end
  }
  GetBillcount() {
    this.Financialyear =
      $("#id_ddlFinancialyear").val() == '' ? '' : $("#id_ddlFinancialyear").val();
    this._appService
      .GetByTwoId("Bills", "GetBillStatusCount", this.CompanyId, this.Financialyear)
      .subscribe(
        (response) => {
          this.DashboardData.DraftCount = response[0].DraftCount;
          this.DashboardData.AuthorizedCount = response[0].AuthorizedCount;
          this.DashboardData.PostedCount = response[0].PostedCount;
          this.DashboardData.PendingPaymentsCount =
            response[0].PendingPaymentsCount;
          this.DashboardData.PaidCount = response[0].PaidCount;
          this.DashboardData.DeletedCount = response[0].DeletedCount;
          this.DashboardData.AllCount = response[0].AllCount;
        },
        (err) => { }
      );
  }
  GetBillById(Id) {
    const that = this;
    if (this.isEdit == false) {
      this.isEdit = true;
      Helpers.setLoading(true);
      that.billsComponent._appService
        .GetById("Bills", "GetBillsById", Id)
        .subscribe(
          (response) => {
            this.ShowAttachment = true;
            that.billsComponent.ClearData();
            that.billsComponent.ClearValidations();
            this.ChargesList = [];
            that.billsComponent.ShowVendorDetails = true;
            that.billsComponent.showbill = true;
            that.billsComponent.IsNewCase = true;
            that.billsComponent.Bills = response;

            that.billsComponent.Bills.TDSRates = response.TDSAmount;

            if (that.billsComponent.Bills.VendorName != null) {
              that.billsComponent.Bills.TranspoterId = response.VendorId;
              this.GetBalancedAdvance(that.billsComponent.Bills.VendorId);
            } else if (that.billsComponent.Bills.DriverName != null) {
              that.billsComponent.Bills.TranspoterId = response.DriverId;
              this.GetBalancedAdvance(that.billsComponent.Bills.DriverId);
            }

            var Count: any = 0;
            if (that.billsComponent.Bills != null) {
              //add by maaria on 20-10-2023
              this.isDebit = that.billsComponent.Bills.isDebit;

              // if (that.billsComponent.Bills.isDebit == true) {
              //   that.billsComponent.Bills.BillsDetails.forEach((element) => {
              //     that.billsComponent.ChargesList.push({
              //       THCName: element.THCName,
              //       THC: element.THC,
              //       ChargeName: element.ChargeName,
              //       HSNNo: element.HSNNo,
              //       GstMaster:
              //         element.GstMaster != null
              //           ? that.billsComponent.GSTMasterList.find(
              //             (x) => x.Id == element.GstMaster
              //           ).Label
              //           : "NA",

              //       GSTMasterId: element.GstMaster,
              //       BasedOn: element.BasedOn,
              //       Quantity: element.Quantity,
              //       Rate: element.Rate < 0 ? -element.Rate : element.Rate,
              //       Discount: element.Discount < 0 ? -element.Discount : element.Discount,
              //       Amount: element.Amount < 0 ? -element.Amount : element.Amount,
              //       BillDetailId: element.BillDetailId,
              //       TranspoterId: that.billsComponent.Bills.VendorId,
              //       ChargeAccount: element.ChargeName,
              //       Id: Count,
              //       VehicleId: element.VehicleId,
              //       TyreId: element.TyreId,
              //       VehicleNo: element.VehicleNo,
              //       TyreNo: element.TyreNo,
              //       Odometer: element.Odometer,
              //       VehicleDispatchDate: element.VehicleDispatchDate,
              //       TDS: element.TDS,
              //       TDSAmount: element.TDSAmount,
              //       //added by vithujan 23-06-2023
              //       TDSName: element.TDSName
              //     });
              //     Count = Count + 1;
              //   });

              // }
              // else {
              that.billsComponent.Bills.BillsDetails.forEach((element) => {
                that.billsComponent.ChargesList.push({
                  THCName: element.THCName,
                  THC: element.THC,
                  ChargeName: element.ChargeName,
                  HSNNo: element.HSNNo,
                  GstMaster:
                    element.GstMaster != null
                      ? that.billsComponent.GSTMasterList.find(
                        (x) => x.Id == element.GstMaster
                      ).Label
                      : "NA",

                  GSTMasterId: element.GstMaster,
                  BasedOn: element.BasedOn,
                  Quantity: element.Quantity,
                  Rate: element.Rate,
                  Discount: element.Discount,
                  Amount: element.Amount,
                  BillDetailId: element.BillDetailId,
                  TranspoterId: that.billsComponent.Bills.VendorId,
                  ChargeAccount: element.ChargeName,
                  Id: Count,
                  VehicleId: element.VehicleId,
                  TyreId: element.TyreId,
                  VehicleNo: element.VehicleNo,
                  TyreNo: element.TyreNo,
                  Odometer: element.Odometer,
                  VehicleDispatchDate: element.VehicleDispatchDate,
                  TDS: element.TDS,
                  TDSAmount: element.TDSAmount,
                  //added by vithujan 23-06-2023
                  TDSName: element.TDSName,
                });
                Count = Count + 1;
              });
              // }

              //end

              // that.billsComponent.Bills.BillsDetails.forEach((element) => {
              //   that.billsComponent.ChargesList.push({
              //     THCName: element.THCName,
              //     THC: element.THC,
              //     ChargeName: element.ChargeName,
              //     HSNNo: element.HSNNo,
              //     GstMaster:
              //       element.GstMaster != null
              //         ? that.billsComponent.GSTMasterList.find(
              //           (x) => x.Id == element.GstMaster
              //         ).Label
              //         : "NA",

              //     GSTMasterId: element.GstMaster,
              //     BasedOn: element.BasedOn,
              //     Quantity: element.Quantity,
              //     Rate: element.Rate,
              //     Discount: element.Discount,
              //     Amount: element.Amount,
              //     BillDetailId: element.BillDetailId,
              //     TranspoterId: that.billsComponent.Bills.VendorId,
              //     ChargeAccount: element.ChargeName,
              //     Id: Count,
              //     VehicleId: element.VehicleId,
              //     TyreId: element.TyreId,
              //     VehicleNo: element.VehicleNo,
              //     TyreNo: element.TyreNo,
              //     Odometer: element.Odometer,
              //     VehicleDispatchDate: element.VehicleDispatchDate,
              //     TDS: element.TDS,
              //     TDSAmount: element.TDSAmount,
              //     //added by vithujan 23-06-2023
              //     TDSName: element.TDSName
              //   });
              //   Count = Count + 1;
              // });
            }

            $("#BillDate").datepicker(
              "setDate",
              that.billsComponent.datePipe.transform(
                response.BillDate,
                "dd/MM/yyyy"
              )
            );
            $("#BillRefDate").datepicker(
              "setDate",
              that.billsComponent.datePipe.transform(
                response.ReferenceDate,
                "dd/MM/yyyy"
              )
            );
            $("#DueDate").datepicker(
              "setDate",
              that.billsComponent.datePipe.transform(
                response.DueDate,
                "dd/MM/yyyy"
              )
            );
            if (that.billsComponent.Bills.VendorName != null) {
              var SourOptions =
                '<option value="' +
                that.billsComponent.Bills.VendorId +
                '">' +
                that.billsComponent.Bills.VendorName +
                "</option>";
              $("#VendorName").html(SourOptions);
              that.billsComponent.Bills.VendorId = response.VendorId;
            } else if (that.billsComponent.Bills.DriverName != null) {
              var SourOptions =
                '<option value="' +
                that.billsComponent.Bills.DriverId +
                '">' +
                that.billsComponent.Bills.DriverName +
                "</option>";
              $("#VendorName").html(SourOptions);
              that.billsComponent.Bills.VendorId = response.DriverId;
            }
            // add kevin 13-Dec-2021 FuelPump
            if (that.billsComponent.Bills.FulePumpName != null) {
              var SourOptions =
                '<option value="' +
                that.billsComponent.Bills.FulePumpId +
                '">' +
                that.billsComponent.Bills.FulePumpName +
                "</option>";
              $("#FuelPump").html(SourOptions);
            }
            //end
            if (that.billsComponent.Bills.THCName != null) {
              var SourOptionsTHC =
                '<option value="' +
                that.billsComponent.Bills.THC +
                '">' +
                that.billsComponent.Bills.THCName +
                "</option>";
              $("#THC").html(SourOptionsTHC);
            }

            //SET TEXT AREA
            $("#Remarks").val(response.Remark);
            $("#PaymentTermsRemark").val(response.PaymentTermsRemark);
            //Reffrece Dropdown

            //added by vithujan 08-02-2024 - Siddarth
            var OptionSelectBillno = "";
            OptionSelectBillno +=
              '<option value="' +
              response.BillRefId +
              '">' +
              response.BillRefNo +
              "</option>";
            $("#BillNoSelect").html(OptionSelectBillno);
            $("#BillNoSelect").val(response.BillRefId).change();

            that.billsComponent.RefreshParentDropdown();
            that.billsComponent.calcGST();

            if (response.IsAuthorized == false) {
              $("#btnSaveForBill").prop("disabled", false);
              $("#btnAuthorizedForBill").prop("disabled", false);
              $("#btnPostForBill").prop("disabled", true);
              that.billsComponent.IsAuthorized = false;
              that.billsComponent.IsPosted = false;
            } else {
              $("#btnSaveForBill").prop("disabled", true);
              $("#btnAuthorizedForBill").prop("disabled", true);
              if (response.IsPosted == true) {
                that.billsComponent.IsPosted = true;
                $("#btnPostForBill").prop("disabled", true);
                $("#btnSavePD").prop("disabled", true);
              } else {
                that.billsComponent.IsAuthorized = true;
                $("#btnPostForBill").prop("disabled", false);
              }
            }
            this.IsPushedtoERP = response.IsPushedtoERP;

            this.NetAppliedAdvance = this.Bills.AppliedAdvance;
            this.AppliedAdvanceTDS =
              this.Bills.AppliedAdvanceTDS == undefined
                ? 0
                : this.Bills.AppliedAdvanceTDS;
            this.NetAppliedAdvanceTDS = this.Bills.AppliedAdvanceTDS;
            // this.Bills.TDSRates -= this.Bills.AppliedAdvanceTDS;
            // this.Bills.NetTotal =
            //   this.Bills.NetTotal -
            //   this.Bills.AppliedAdvance -
            //   this.Bills.PaymentAgainstBill;
            //hem change

            // this.Bills.AppliedAdvance = this.AppliedAdvance;
            // this.Bills.AppliedAdvanceTDS = this.AppliedAdvanceTDS;

            if (that.billsComponent.Bills.VendorName != null) {
              this.GetAdvancePaymentDetailById(
                that.billsComponent.Bills.VendorId
              );
            } else if (that.billsComponent.Bills.DriverName != null) {
              this.GetAdvancePaymentDetailById(
                that.billsComponent.Bills.DriverId
              );
            }
            //added by vithujan 23-02-2023
            setTimeout(() => {
              document.getElementById("VendorName").focus();
              (<any>$("#se_PrintBill")).selectpicker("refresh");
              (<any>$("#se_DownloadBill")).selectpicker("refresh");
            }, 100);
            //end
            Helpers.setLoading(false);
            this.isEdit = false;
          },
          (err) => {
            this.toastr.error(
              "An erro occured while Update Data",
              "ShipmentMode"
            );
            Helpers.setLoading(false);
            this.isEdit = false;
          }
        );
    }
  }

  CheckRereferenceNo(Id) {
    this._appService
      .GetById("Bills", "CheckRereferenceNo", Id)
      .subscribe((response) => {
        if (response != "") {
          swal(response, "", "info");
        }
      });
  }

  OnChangeUnit() {
    const that = this;
    if (that.billsComponent.Bills.ChargeType == "Account") {
      that.billsComponent.ChargeObj.Quantity = 0;
    } else {
      if (this.ChargeObj.BasedOn == "Weight") {
        this.ChargeObj.Quantity = this.Bills.PaidWeight;
      } else if (this.ChargeObj.BasedOn == "Package") {
        this.ChargeObj.Quantity = this.Bills.TotalQuantity;
      } else if (this.ChargeObj.BasedOn == "Vehicle") {
        this.ChargeObj.Quantity = 1;
      } else if (this.ChargeObj.BasedOn == "Shortage") {
        this.ChargeObj.Quantity = this.Bills.ShortageQuantity;
      } else {
        this.ChargeObj.Quantity = 1;
      }
    }
    this.PopChangeData();
  }

  BtnDelete(index) {
    this.ChargesList.splice(index, 1);
    this.calcGST();

    //added by vithujan 02-06-2023
    if (this.isISAUrl == true) {
      this.AutoSetOffAdvance();
    }
  }

  ChargeDataGet() {
    if (this.Bills.ChargeType == "Charge") {
      this._appService
        .GetByTwoId(
          "Bills",
          "GetBillDetailsData",
          this.ChargeObj.TranspoterId,
          this.ChargeObj.ChargeName
        )
        .subscribe((Response) => {
          if (Response.data > 0) {
            this.ChargeObj.Rate = Response.data[0].Rate;
          }
        });
    }
  }

  BtnEdit(data) {
    const that = this;
    // this.Bills = this.ChargesList.find(x => x.Id == Id);
    this.ChargeObj = data;
    this.ClearValidationsForCharges();

    // $('#Charges').val(that.billsComponent.ChargeObj.ChargeName);

    //add kevin 16/10/2020
    var THCOptions =
      '<option value="' +
      that.billsComponent.ChargeObj.THC +
      '">' +
      that.billsComponent.ChargeObj.THCName +
      "</option>";
    $("#THC").html(THCOptions);
    //end
    //add kevin 09-Mar-2022
    if (this.ChargeObj.VehicleNo != null) {
      var selectVehicleNoOptions =
        '<option value="' +
        this.ChargeObj.VehicleId +
        '">' +
        this.ChargeObj.VehicleNo +
        $("#selectVehicleNo").html(selectVehicleNoOptions);
    }
    if (this.ChargeObj.TyreNo != null) {
      var selectTyreNoOptions =
        '<option value="' +
        this.ChargeObj.TyreId +
        '">' +
        this.ChargeObj.TyreNo +
        "</option>";
      $("#selectTyreNo").html(selectTyreNoOptions);
    }
    //end
    var SourOptions =
      '<option value="' +
      that.billsComponent.ChargeObj.ChargeName +
      '">' +
      that.billsComponent.ChargeObj.ChargeName +
      "</option>";
    $("#Charges").html(SourOptions);
    if (this.ChargeObj != undefined) {
      if (
        this.ChargeObj.GSTMasterId != undefined &&
        this.ChargeObj.GSTMasterId != "NA"
      )
        this.ChargeObj.GstMaster = this.GSTMasterList.find(
          (x) => x.Id == this.ChargeObj.GSTMasterId
        ).Label;
    }
    // alert(JSON.stringify(this.ChargeObj));

    //added by vithujan 02-06-2023
    if (this.isISAUrl == true) {
      this.AutoSetOffAdvance();
    }

    $("#BillModel").modal("show");
    window.scrollTo(0, 0);
    setTimeout(() => {
      if (this.ChargeObj.GSTMasterId != null)
        $("#GSTMaster").val(this.ChargeObj.GSTMasterId);
      else {
        $("#GSTMaster").val("NA");
      }
      this.RefreshParentDropdown();
    }, 200);
  }

  ClearDashBoardData() {
    const that = this;
    that.billsComponent.DashboardData.DraftCount = 0;
    that.billsComponent.DashboardData.AuthorizedCount = 0;
    that.billsComponent.DashboardData.PostedCount = 0;
    that.billsComponent.DashboardData.PendingPaymentsCount = 0;
    that.billsComponent.DashboardData.PaidCount = 0;
    that.billsComponent.DashboardData.DeletedCount = 0;
    that.billsComponent.DashboardData.AllCount = 0;
  }

  ClearData() {
    this.CGSTAmount = 0;
    this.SGSTAmount = 0;
    this.IGSTAmount = 0;
    this.SubTotal = 0;
    $("#Remarks").val("");
    $("#PaymentTermsRemark").val("");
  }

  SearchStatus(Status) {
    this.selectedCard = Status;
    this.GetBillcount();
    this.datatableBills.search(Status, "Status");
    this.grandTotal = 0;
    this.TotalOfBalanceDue = 0;

    //added by vithujan 20-02-2023
    setTimeout(() => {
      var rows = BillsComponent.bc.datatableBills;
      rows.rows(".m-datatable__row");
      BillsComponent.bc.totalRowsCount = rows.nodes().length;
      BillsComponent.bc.rowIndex = -1;
    }, 2000);
    //end
  }

  GetFormattedDate(Id, ScopeValue) {
    if (
      moment($("#" + Id).datepicker("getDate")).format("YYYY-MM-DD") !=
      "Invalid date"
    ) {
      ScopeValue = moment($("#" + Id).datepicker("getDate")).format(
        "YYYY-MM-DD"
      );
    } else {
      var date = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      if (date.test(ScopeValue)) {
        var d = new Date(ScopeValue.split("/").reverse().join("-"));
        ScopeValue = this.datePipe.transform(d, "yyyy-MM-dd");
      }
    }
    return ScopeValue;
  }

  //--------------------------Validations------------------------------------

  // ValidateFieldOnAdd

  Validations = function () {
    const that = this;
    var flag = true;
    if (
      !that.billsComponent.commonService.ValidateRequiredField(
        $("#BillDate"),
        "Please Select Date",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !that.billsComponent.commonService.ValidateRequiredField2(
        $("#VendorName"),
        $("#FieldSetVendorName"),
        "Please Select Any One",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !that.billsComponent.commonService.ValidateRequiredField(
        $("#PaymentTerms"),
        "Please Enter Payment Term",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  };

  ClearValidations = function () {
    this.commonService.ClearMessage($("#BillDate"));
    this.commonService.ClearMessage($("#VendorName"));
    this.commonService.ClearMessage($("#FieldSetVendorName"));
    this.commonService.ClearMessage($("#FieldSetPaymentModeType"));
    this.commonService.ClearMessage($("#THC"));
    this.commonService.ClearMessage($("#FieldSetTHC"));
    this.commonService.ClearMessage($("#PaymentTerms"));
  };

  ValidationsForCharges = function () {
    const that = this;
    var flag = true;
    if ($("#GSTMaster").val() != "NA") {
      if (
        !that.billsComponent.commonService.ValidateRequiredField(
          $("#HSNNo"),
          "Please Enter HSN No",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    } else {
      that.billsComponent.commonService.ClearMessage($("#HSNNo"));
    }
    if (
      !that.billsComponent.commonService.ValidateRequiredField2(
        $("#Charges"),
        $("#FieldSetCharge"),
        "Please Select Charge",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !that.billsComponent.commonService.ValidateRequiredField2(
        $("#BasedOn"),
        $("#FieldsetBasedOn"),
        "Please Select Based On",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !that.billsComponent.commonService.ValidateRequiredField(
        $("#Qty"),
        "Please Enter Quantity",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !that.billsComponent.commonService.ValidateRequiredField(
        $("#Rate"),
        "Please Enter Rate",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (this.Bills.ChargeType == "Charge") {
      if (
        !that.billsComponent.commonService.ValidateRequiredField2(
          $("#THC"),
          $("#FieldSetTHC"),
          "Please Select THC",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    } else {
      this.commonService.ClearMessage($("#THC"));
      this.commonService.ClearMessage($("#FieldSetTHC"));
    }

    // add kevin 08-Mar-2022
    if (this.Bills.ChargeType == "RepairsAndMaintenance") {
      var isSelectAny = 0;
      if (
        !that.billsComponent.commonService.ValidateRequiredField2(
          $("#selectVehicleNo"),
          $("#FieldSetSelectVehicleNo"),
          "Please Select Vehicle No",
          "after",
          ""
        )
      ) {
        if (flag == true) {
          isSelectAny = 3;
        }
        flag = false;
      } else {
        isSelectAny = 1;
      }
      if (isSelectAny == 0 || isSelectAny == 3) {
        if (
          !that.billsComponent.commonService.ValidateRequiredField2(
            $("#selectTyreNo"),
            $("#FieldSetSelectTyreNo"),
            "Please Select Tyre",
            "after",
            ""
          )
        ) {
          flag = false;
        } else {
          that.billsComponent.commonService.ClearMessage($("#selectVehicleNo"));
          that.billsComponent.commonService.ClearMessage(
            $("#FieldSetSelectVehicleNo")
          );
          if (isSelectAny == 3) {
            flag = true;
          }
        }
      }
    } else {
      that.billsComponent.commonService.ClearMessage($("#selectVehicleNo"));
      that.billsComponent.commonService.ClearMessage(
        $("#FieldSetSelectVehicleNo")
      );
      that.billsComponent.commonService.ClearMessage($("#selectTyreNo"));
      that.billsComponent.commonService.ClearMessage(
        $("#FieldSetSelectTyreNo")
      );
    }
    // end

    return flag;
  };

  ClearValidationsForCharges = function () {
    this.commonService.ClearMessage($("#HSNNo"));
    this.commonService.ClearMessage($("#GSTMaster"));
    this.commonService.ClearMessage($("#Chargefieldset"));
    this.commonService.ClearMessage($("#FieldSetCharge"));
    this.commonService.ClearMessage($("#BasedOn"));
    this.commonService.ClearMessage($("#FieldsetBasedOn"));
    this.commonService.ClearMessage($("#Qty"));
    this.commonService.ClearMessage($("#Rate"));
    this.commonService.ClearMessage($("#THC"));
    this.commonService.ClearMessage($("#FieldSetTHC"));
  };

  TypeChange(ChargeType) {
    const that = this;
    if (this.ChargesList.length > 0) {
      swal({
        title: "Are you sure?",
        text: "All Charges / Account you added below will be deleted. You won't be able to revert this!",
        type: "warning",
        showCancelButton: !0,
        confirmButtonText: "Yes, delete it!",
      }).then(function (e) {
        if (e.value == true) {
          that.billsComponent.ChargesList = [];
          that.billsComponent.calcGST();
          that.billsComponent.Bills.NetTotal = 0;
        } else {
          that.billsComponent.Bills.ChargeType = "Charge";
          that.billsComponent.RefreshParentDropdown();
        }
      });
    }
  }
  //-------------------------Authorize------------------------
  AuthorizeBill() {
    Helpers.setLoading(true);
    this._appService
      .GetByThreeId(
        "Common",
        "AuthorizeTransaction",
        3,
        this.Bills.Id,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          $("#btnSaveForBill").prop("disabled", true);
          $("#btnAuthorizedForBill").prop("disabled", true);
          $("#btnPostForBill").prop("disabled", false);
          this.IsAuthorized = true;
          this.IsPosted = false;
          if (response == 8) {
            this.toastr.error("Please Map TDS before posting!");
            $("#btnSaveForBill").prop("disabled", false);
            $("#btnAuthorizedForBill").prop("disabled", false);
            return;
          }
          this.toastr.success("Bill Authorized Successfully !", "Success");
        },
        (err) => {
          this.toastr.error("An error occured  !", "Error");
        }
      );
    Helpers.setLoading(false);
  }

  PostPurchaseBill() {
    if (this.Bills.NetTotal != 0) {
      Helpers.setLoading(true);
      this._appService
        .GetByTwoId("Bills", "PostPurchaseBill", this.Bills.Id, this.CompanyId)
        .subscribe(
          (response) => {
            if (response == 100) {
              this.toastr.error(
                "Please Configure Reverse Tax  in Manage Taxes !",
                "Error"
              );
            }
            else if (response == 11) {
              this.toastr.info("Network is unauthorised", 'error')
              return;
            }
            else if (response == 2) {
              this.toastr.info("Chart of Account not found", 'Info');
              return;
            }
            else {
              this.toastr.success("Bill Posted Successfully !", "Success");
              this.IsAuthorized = false;
              this.grandTotal = 0;
              this.TotalOfBalanceDue = 0;
              this.IsPosted = true;
              this.GetJVSummaryData();
              $("#btnPostForBill").prop("disabled", true);
            }
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
      Helpers.setLoading(false);
    } else {
      this.toastr.error("Zero amount bill is not allowed to Post !", "Error");
    }
  }

  DeletePurchaseBill(Id) {
    const that = this;
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      if (e.value == true) {
        that.billsComponent._appService
          .Delete("Bills", "DeleteBills", Id)
          .subscribe(
            (response) => {
              let resSTR = JSON.stringify(response);
              let resJSON = JSON.parse(resSTR);
              //alert(resJSON._body);
              if (resJSON._body == 100) {
                that.billsComponent.toastr.warning(
                  "You can't delete Bill because payment is already made. ",
                  "warning"
                );
              } else {
                //added by vithujan 19-10-2023
                that.billsComponent.SaveDeletedTransactionHistory(Id);
                that.billsComponent.toastr.success(
                  "Bills Deleted Successfully ",
                  "Success"
                );

                that.billsComponent.ClearDashBoardData();
                that.billsComponent.datatableBills.destroy();
                that.billsComponent.GetBillsList();

                //Bills Shared Components datatable reload functionality
                //Retreading
                if (
                  $("#m_datatable_TyreRetreadingBillList").mDatatable() !=
                  undefined
                ) {
                  $("#m_datatable_TyreRetreadingBillList")
                    .mDatatable()
                    .reload();
                }
                //Repair
                if (
                  $("#m_datatable_TyreRepairBillList").mDatatable() != undefined
                ) {
                  $("#m_datatable_TyreRepairBillList").mDatatable().reload();
                }
                //Issue
                if ($("#m_datatable_IssueBillList").mDatatable() != undefined) {
                  $("#m_datatable_IssueBillList").mDatatable().reload();
                }
                //Tyre List
                if (
                  $("#m_datatable_TyrePurchaseBillList").mDatatable() !=
                  undefined
                ) {
                  $("#m_datatable_TyrePurchaseBillList").mDatatable().reload();
                }
              }
            },
            (err) => {
              that.billsComponent.toastr.error(
                err._body.replace(/"/g, ""),
                "Error"
              );
            }
          );
      }
    });
  }

  OnShowPaymentDetail() {
    if ($("#btnShowPaymentDetails")[0].classList.value == "fa fa-plus") {
      $("#btnShowPaymentDetails").removeClass("fa-plus");
      $("#btnShowPaymentDetails").addClass("fa-minus");
      $("#ShowBillPaymentDetails").slideToggle();
      this.GetPaymentSummaryData();
    } else {
      $("#btnShowPaymentDetails").addClass("fa-plus");
      $("#btnShowPaymentDetails").removeClass("fa-minus");
      $("#ShowBillPaymentDetails").slideToggle();
      this.PaymentSummaryData = [];
    }
  }

  GetPaymentSummaryData() {
    if (this.Bills.Id != null && this.Bills.Id != undefined) {
      Helpers.setLoading(true);
      this._appService
        .GetById("Bills", "GetBillPaymentSummary", this.Bills.Id)
        .subscribe(
          (response) => {
            this.PaymentSummaryData = response;
          },
          (err) => {
            this.toastr.error("An error occured  !", "error");
          }
        );
      Helpers.setLoading(false);
    }
  }

  OnShowJVDetail() {
    if ($("#btnShowBillJVDetails")[0].classList.value == "fa fa-plus") {
      $("#btnShowBillJVDetails").removeClass("fa-plus");
      $("#btnShowBillJVDetails").addClass("fa-minus");
      $("#ShowJVBillDetails").slideToggle();
      this.GetJVSummaryData();
    } else {
      $("#btnShowBillJVDetails").addClass("fa-plus");
      $("#btnShowBillJVDetails").removeClass("fa-minus");
      $("#ShowJVBillDetails").slideToggle();
      this.JVSummaryData = [];
    }
  }

  GetJVSummaryData() {
    if (this.Bills.Id != null && this.Bills.Id != undefined) {
      Helpers.setLoading(true);
      this._appService
        .GetById("Sales", "GetJournalEntrySummary", this.Bills.Id)
        .subscribe(
          (response) => {
            this.JVSummaryData = response;
          },
          (err) => {
            this.toastr.error("An error occured  !", "error");
          }
        );
      Helpers.setLoading(false);
    }
  }

  ShowPendingIssueBillList() {
    $("#PendingIssueBillModal").modal("show");
    setTimeout(() => {
      this.GetPendingIssueBills();
    }, 500);
  }

  GetPendingIssueBills() {
    this.datatableForPendingBill = (<any>(
      $("#tblPendingIssueBillList")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url:
              environment.apiUrl + "api/Bills/GetPendingPaymentRequetBillList",
            params: {
              ReferenceType: 1,
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      // search: {
      //     onChange: true,
      //     input: $('#SearchValue'),
      //     delay: 400,
      // },
      rows: {},
      columns: [
        {
          field: "VehicleNo",
          title: "Vehicle",
          sortable: false,
          width: 180,
        },
        {
          field: "Summary",
          title: "Issue Summary",
          sortable: false,
          width: 180,
        },
      ],
    });
  }

  GetBalancedAdvance(Id) {
    this._appService
      .GetByTwoId("Bills", "GetBalanceAdvancePayment", Id, this.CompanyId)
      .subscribe(
        (Response) => {
          if (Response != null) {
            this.BalanceAdvanceAmount = Response.BalanceAdvanceAmount;
            this.BalanceTDS = Response.BalanceTDS;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occured while fetching Balanced Advance Amount",
            "Error"
          );
        }
      );
  }

  GetAdvancePaymentDetailById(Id) {
    this.Bills.VendorName = $("#VendorName").text();
    this.Bills.THCName = $("#THC").text();

    this._appService
      .GetByTwoId("Bills", "GetAdvancePaymentDetailById", Id, this.CompanyId)
      .subscribe(
        (Response) => {
          if (Response != null) {
            this.AdvancePaymentDetailList = Response;
            this.CalculateNetAmountForAdvance();
          }
        },
        (err) => {
          this.toastr.error(
            "Error occured while fetching Advance Payment Detail of the Vendor",
            "Error"
          );
        }
      );
  }

  CalculateNetAmountForAdvance() {
    // this.ValidateAdvancePaymentfield();
    this.BillAmountWithTax = 0;
    this.TotalAdvanceLeft = 0;
    this.TotalTDSLeft = 0;
    this.TotalAppliedAdvance = 0;
    this.TotalAppliedTDS = 0;

    // this.Bills.AppliedAdvance = this.Bills.AppliedAdvance == undefined ? 0 : this.Bills.AppliedAdvance;
    // this.Bills.AppliedAdvanceTDS = this.Bills.AppliedAdvanceTDS == undefined ? 0 : this.Bills.AppliedAdvanceTDS;

    this.AppliedAdvance =
      this.Bills.AppliedAdvance == undefined ? 0 : this.Bills.AppliedAdvance;
    this.AppliedAdvanceTDS =
      this.Bills.AppliedAdvanceTDS == undefined
        ? 0
        : this.Bills.AppliedAdvanceTDS;

    this.AppliedAdvance = 0;
    this.AppliedAdvanceTDS = 0;

    this.AdvancePaymentDetailList.forEach((element) => {
      this.TotalAdvanceLeft = this.TotalAdvanceLeft + element.BalanceAdvance;
      this.TotalTDSLeft = this.TotalTDSLeft + element.BalanceTDS;
      this.TotalAppliedAdvance = this.TotalAppliedAdvance + element.PaidAmount;
      this.TotalAppliedTDS = this.TotalAppliedTDS + element.TDSAmount;
    });

    this.TotalAdvanceLeft = parseFloat(this.TotalAdvanceLeft.toFixed(2));
    this.TotalTDSLeft = parseFloat(this.TotalTDSLeft.toFixed(2));
    this.TotalAppliedAdvance = parseFloat(this.TotalAppliedAdvance.toFixed(2));
    this.TotalAppliedTDS = parseFloat(this.TotalAppliedTDS.toFixed(2));

    this.BillAmountWithTax =
      this.SubTotal + this.CGSTAmount + this.SGSTAmount + this.IGSTAmount;
    this.BillAmountWithTax = parseFloat(this.BillAmountWithTax.toFixed(2));

    this.AppliedAdvance = this.AppliedAdvance + this.TotalAppliedAdvance;
    this.AppliedAdvanceTDS = this.AppliedAdvanceTDS + this.TotalAppliedTDS;

    this.GetNetAdvanceBalanceAmount();
  }

  BalanceDue: any = 0;
  GetNetAdvanceBalanceAmount() {
    this.NetPayableBillAmount = 0;
    this.BalanceDue = 0;
    this.BalanceBillAmount = 0;
    this.BalanceTDSAmount = 0;
    // if (
    //   this.Bills.TDS != null &&
    //   this.Bills.TDS != undefined &&
    //   this.Bills.TDS != ""
    // ) {
    // var TDSRateIn = this.TDSMasterList.find((x) => x.Id == this.Bills.TDS).RateIn;
    // this.Bills.TDSRates = (this.SubTotal * TDSRateIn) / 100;
    this.Bills.AppliedAdvanceTDS =
      this.Bills.AppliedAdvanceTDS == undefined
        ? 0
        : this.Bills.AppliedAdvanceTDS;
    this.Bills.TDSRates -= this.Bills.AppliedAdvanceTDS;
    this.Bills.TDSRates = parseFloat(this.Bills.TDSRates.toFixed(2));
    // }

    this.Bills.NetTotal =
      this.Bills.NetTotal == undefined ? 0 : this.Bills.NetTotal;
    if (this.Bills.IsReverseChargeApplicable == true) {
      this.Bills.NetTotal = parseFloat(
        (this.SubTotal - this.Bills.TDSRates).toFixed(2)
      );
    } else {
      this.Bills.NetTotal = parseFloat(
        (
          this.CGSTAmount +
          this.SGSTAmount +
          this.IGSTAmount +
          this.SubTotal -
          this.Bills.TDSRates
        ).toFixed(2)
      );
    }
    this.Bills.RoundOfAmount = parseFloat(
      (Math.round(this.Bills.NetTotal) - this.Bills.NetTotal).toFixed(2)
    );
    this.Bills.NetTotal = Math.round(this.Bills.NetTotal);

    this.Bills.PaymentAgainstBill =
      this.Bills.PaymentAgainstBill == undefined
        ? 0
        : this.Bills.PaymentAgainstBill;
    this.Bills.AppliedAdvance =
      this.Bills.AppliedAdvance == undefined ? 0 : this.Bills.AppliedAdvance;
    this.Bills.AppliedAdvanceTDS =
      this.Bills.AppliedAdvanceTDS == undefined
        ? 0
        : this.Bills.AppliedAdvanceTDS;

    this.BalanceBillAmount =
      this.Bills.NetTotal -
      this.Bills.AppliedAdvance -
      this.AppliedAdvance -
      this.Bills.PaymentAgainstBill -
      this.Bills.AppliedAdvanceTDS;
    this.BalanceBillAmount = parseFloat(this.BalanceBillAmount.toFixed(2));

    this.Bills.TDSRates =
      this.Bills.TDSRates == undefined ? 0 : this.Bills.TDSRates;
    //hem change
    this.BalanceTDSAmount = this.Bills.TDSRates - this.AppliedAdvanceTDS;
    this.BalanceTDSAmount = parseFloat(this.BalanceTDSAmount.toFixed(2));

    //hem change
    this.NetPayableBillAmount = this.BalanceBillAmount;
    this.NetPayableBillAmount = parseFloat(
      this.NetPayableBillAmount.toFixed(2)
    );

    this.BalanceDue =
      this.Bills.NetTotal -
      this.Bills.AppliedAdvance -
      this.AppliedAdvance -
      this.Bills.PaymentAgainstBill -
      this.Bills.AppliedAdvanceTDS;
    this.BalanceDue = parseFloat(this.BalanceDue.toFixed(2));

    this.ValidateBalanceAmount();
  }

  ValidateAdvancePaymentfield() {
    var flag = true;
    var i = 0;
    this.AdvancePaymentDetailList.forEach((element) => {
      this.commonService.ClearMessage($("#AdvancePayment_" + i));
      this.commonService.ClearMessage($("#AdvanceTDS_" + i));
      if (element.PaidAmount > element.BalanceAdvance) {
        flag = false;
        element.PaidAmount = 0;
        $($("#AdvancePayment_" + i))
          .closest(".form-group")
          .addClass("has-error");
        this.toastr.error(
          "Paid Amount is Greater than Advance Left !",
          "Error"
        );
      }
      if (element.TDSAmount > element.BalanceTDS) {
        flag = false;
        element.TDSAmount = 0;
        $($("#AdvanceTDS_" + i))
          .closest(".form-group")
          .addClass("has-error");
        this.toastr.error("TDS Amount is Greater than TDS Left !", "Error");
      }
      i++;
    });
    return flag;
  }
  ValidateBalanceAmount() {
    // add comment 25/03/2020 for allow negative values
    // if (this.BalanceBillAmount < 0) {
    //     swal('Applied Advance Amount is greater than BillAmount !', "", "error");
    //     this.ClearAdvancePaymentDataData(false);
    //     return;
    // }
    // if (this.BalanceTDSAmount < 0) {
    //     swal('Applied Advance TDS is greater than TDS in the Bill !', "", "error");
    //     this.ClearAdvancePaymentDataData(false);
    //     return;
    // }
  }

  ClearAdvancePaymentDataData(IsValid) {
    var i = 0;
    this.AdvancePaymentDetailList.forEach((element) => {
      this.commonService.ClearMessage($("#AdvancePayment_" + i));
      this.commonService.ClearMessage($("#AdvanceTDS_" + i));
      element.PaidAmount = 0;
      element.TDSAmount = 0;
      i++;
    });

    this.NetAppliedAdvance = 0;
    this.NetAppliedAdvanceTDS = 0;
    this.CalculateNetAmountForAdvance();
  }

  SavePaymentDetail() {
    var PaymentData = [];
    this.AdvancePaymentDetailList.forEach((element) => {
      if (!(element.PaidAmount == 0 && element.TDSAmount == 0)) {
        var obj: any = {};
        jQuery.extend(true, {}, obj);
        obj.BillPaymentId = element.Id;
        obj.BillId = this.Bills.Id;
        obj.PaidAmount = element.PaidAmount;
        obj.TDSAmount = element.TDSAmount;
        obj.Id = element.BillPaymentDetailId;
        PaymentData.push(obj);
      }
    });
    if (PaymentData.length > 0) {
      //   this.SaveBills();
      this._appService
        .Post("BillPayment", "SaveBillPaymentDetails", PaymentData)
        .subscribe(
          (response) => {
            if (response.length > 0) {
              $("#AdvancePayment").modal("hide");
              // response.forEach(element => {
              //     this.AdvancePaymentDetailList.forEach(Advancelist => {
              //         if (element.BillPaymentId == Advancelist.Id) {
              //             Advancelist.BillPaymentDetailId = element.Id;
              //         }
              //     });

              // });

              this.AdvancePaymentDetailList.forEach((Advancelist) => {
                response.forEach((element) => {
                  if (element.BillPaymentId == Advancelist.Id) {
                    Advancelist.BillPaymentDetailId = element.Id;
                  }
                });
              });
            }
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          }
        );
    }
  }

  ShowPaymentDetialModal() {
    if (
      this.Bills.VendorId != undefined &&
      this.Bills.VendorId != null &&
      this.Bills.VendorId != ""
    ) {
      $("#AdvancePayment").modal("show");
    } else {
      this.toastr.error("Please Select Vendor", "Error");
    }
  }

  DraftPaymentDetail() {
    $("#AdvancePayment").modal("hide");
    this.CalculateNetAmountForAdvance();
    // if (
    //   this.Bills.TDS != null &&
    //   this.Bills.TDS != undefined &&
    //   this.Bills.TDS != ""
    // ) {
    //   var TDSRateIn = this.TDSMasterList.find((x) => x.Id == this.Bills.TDS).RateIn;
    //   this.Bills.TDSRates = (this.SubTotal * TDSRateIn) / 100;
    //   this.Bills.AppliedAdvanceTDS = this.Bills.AppliedAdvanceTDS == undefined ? 0 : this.Bills.AppliedAdvanceTDS;
    //   this.Bills.TDSRates -= this.Bills.AppliedAdvanceTDS;
    //   this.Bills.TDSRates = parseFloat(this.Bills.TDSRates.toFixed(2));
    // }

    this.TDSMain = 0;
    this.ChargesList.forEach((element) => {
      this.TDSMain = this.TDSMain + element.TDSAmount;
    });
    this.TDSMain = parseFloat(this.TDSMain.toFixed(2));
    this.Bills.TDSRates = this.TDSMain;
    this.Bills.AppliedAdvanceTDS =
      this.Bills.AppliedAdvanceTDS == undefined
        ? 0
        : this.Bills.AppliedAdvanceTDS;
    this.Bills.TDSRates -= this.Bills.AppliedAdvanceTDS;
    this.Bills.TDSRates = parseFloat(this.Bills.TDSRates.toFixed(2));

    this.NetAppliedAdvanceTDS = 0;
    this.NetAppliedAdvance = this.Bills.AppliedAdvance;
    this.NetAppliedAdvanceTDS = this.Bills.AppliedAdvanceTDS;

    this.NetAppliedAdvance += this.AppliedAdvance;
    this.NetAppliedAdvanceTDS += this.AppliedAdvanceTDS;

    //hem change

    //this.BalanceDue = (this.Bills.NetTotal + this.SGSTAmount + this.IGSTAmount) - (this.Bills.PaymentAgainstBill) - (this.NetAppliedAdvance);// - (this.NetAppliedAdvanceTDS);
    // this.BalanceDue =
    //   this.Bills.NetTotal -
    //   this.Bills.PaymentAgainstBill -
    //   this.NetAppliedAdvance;
    // this.BalanceDue = (this.Bills.NetTotal) - (this.Bills.PaymentAgainstBill) - (this.NetAppliedAdvance);// - (this.NetAppliedAdvanceTDS);
    this.BalanceDue = parseFloat(this.BalanceDue.toFixed(2));

    this.Bills.TDSRates -= this.AppliedAdvanceTDS;
    if (this.Bills.IsReverseChargeApplicable == true) {
      this.Bills.NetTotal = parseFloat(
        (this.SubTotal - this.Bills.TDSRates).toFixed(2)
      );
    } else {
      this.Bills.NetTotal = parseFloat(
        (
          this.CGSTAmount +
          this.SGSTAmount +
          this.IGSTAmount +
          this.SubTotal -
          this.Bills.TDSRates
        ).toFixed(2)
      );
    }
    // this.Bills.AppliedAdvance = this.AppliedAdvance;
    // this.Bills.AppliedAdvanceTDS = this.AppliedAdvanceTDS;
  }

  //Attachment
  OnAttachmentClick() {
    $("#DocumentFrom").val("Bills");
    this.AttachmentChild.DocumentType = "Bills";
    this.AttachmentChild.DocumentTransaction = this.Bills.Id;
    this.AttachmentChild.IsSearchHidden = true;
    if (this.AttachmentChild.datatable) {
      this.AttachmentChild.datatable.destroy();
      this.AttachmentChild.GetDocumentsList();
      this.AttachmentChild.datatable.search(
        this.AttachmentChild.DocumentTransaction,
        "ReferenceId"
      );
      this.AttachmentChild.getAttachmentList(
        this.AttachmentChild.DocumentTransaction
      );
    }
  }

  //add kevin 08/08/2020
  ValidateNetAmountForAdvance(index: number) {
    var ValidateTotalAppliedAdvance = 0;
    this.AdvancePaymentDetailList.forEach((element) => {
      ValidateTotalAppliedAdvance =
        ValidateTotalAppliedAdvance + element.PaidAmount;
    });
    if (ValidateTotalAppliedAdvance <= this.Bills.NetTotal) {
      this.CalculateNetAmountForAdvance();
    } else {
      this.toastr.error("Paid Amount is Greater than Net Amount !", "Error");
      $($("#AdvancePayment_" + index))
        .closest(".form-group")
        .addClass("has-error");
      this.AdvancePaymentDetailList[index].PaidAmount = 0;
      this.CalculateNetAmountForAdvance();
      // this.AppliedAdvance =
      //   this.Bills.AppliedAdvance == undefined ? 0 : this.Bills.AppliedAdvance;
      // ValidateTotalAppliedAdvance = 0;
      // this.TotalAppliedAdvance = 0;
      // this.AdvancePaymentDetailList.forEach((element) => {
      //   ValidateTotalAppliedAdvance =
      //     ValidateTotalAppliedAdvance + element.PaidAmount;
      //   this.TotalAppliedAdvance =
      //     this.TotalAppliedAdvance + element.PaidAmount;
      // });
      // this.AppliedAdvance = this.AppliedAdvance + ValidateTotalAppliedAdvance;
      // this.BalanceBillAmount =
      //   this.Bills.NetTotal -
      //   this.Bills.AppliedAdvance -
      //   this.AppliedAdvance -
      //   this.Bills.PaymentAgainstBill;
      // this.BalanceBillAmount = parseFloat(this.BalanceBillAmount.toFixed(2));
    }
  }
  ValidateNetTDSForAdvance(index: number) {
    var ValidateTotalAppliedTDS = 0;
    this.AdvancePaymentDetailList.forEach((element) => {
      ValidateTotalAppliedTDS = ValidateTotalAppliedTDS + element.TDSAmount;
    });
    if (ValidateTotalAppliedTDS <= this.Bills.TDSRates) {
      this.CalculateNetAmountForAdvance();
    } else {
      this.toastr.error("Paid TDS is Greater than Total TDS !", "Error");
      $($("#AdvanceTDS_" + index))
        .closest(".form-group")
        .addClass("has-error");
      this.AdvancePaymentDetailList[index].TDSAmount = 0;
      this.CalculateNetAmountForAdvance();
      //   this.AppliedAdvanceTDS =
      //     this.Bills.AppliedAdvanceTDS == undefined
      //       ? 0
      //       : this.Bills.AppliedAdvanceTDS;
      //   ValidateTotalAppliedTDS = 0;
      //   this.TotalAppliedTDS = 0;
      //   this.AdvancePaymentDetailList.forEach((element) => {
      //     ValidateTotalAppliedTDS = ValidateTotalAppliedTDS + element.TDSAmount;
      //     this.TotalAppliedTDS = this.TotalAppliedTDS + element.TDSAmount;
      //   });
      //   this.AppliedAdvanceTDS = this.AppliedAdvanceTDS + ValidateTotalAppliedTDS;
      //   this.Bills.TDSRates -= this.TotalAppliedTDS;
      //   this.BalanceTDSAmount = this.Bills.TDSRates - this.AppliedAdvanceTDS;
      //   this.BalanceTDSAmount = parseFloat(this.BalanceTDSAmount.toFixed(2));
    }
  }
  //end
  ShowAuditTrail_bill() {
    if ($("#btnShowAuditTrail_bill")[0].classList.value == "fa fa-plus") {
      $("#btnShowAuditTrail_bill").removeClass("fa-plus");
      $("#btnShowAuditTrail_bill").addClass("fa-minus");
      $("#ShowAuditTrail_bill").slideToggle();
    } else {
      $("#btnShowAuditTrail_bill").addClass("fa-plus");
      $("#btnShowAuditTrail_bill").removeClass("fa-minus");
      $("#ShowAuditTrail_bill").slideToggle();
    }
    var Id = this.Bills.Id;
    var pageURL = "Bills";
    this._appService
      .GetByTwoId("Common", "getAuditTrailData", Id, pageURL)
      .subscribe(
        (response) => {
          this.AuditTrailData = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  //add vithujan 10-08-2022
  LoadTaxApplicable() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "IsTaxApplicable")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.TaxApplicableFlag = true;
          } else {
            this.TaxApplicableFlag = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }
  //end

  //added by vithujan 09-01-2023
  disableContextMenu() {
    this.contextmenu = false;
  }

  onrightClick(event) {
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;
    this.contextmenu = true;
  }

  redirectPage(name: any) {
    if (name == "PendingBills") this.router.navigate(["/PendingBills"]);
    if (name == "Expenses") this.router.navigate(["/Expense"]);
    if (name == "PaymentRequest") this.router.navigate(["/PaymentRequest"]);
    if (name == "PaymentMade") this.router.navigate(["/PaymentMade/list"]);
    if (name == "SchedulePayment") this.router.navigate(["/SchedulePayment"]);
  }
  //end

  //added by vithujan 25-01-2023
  showAdvanceSearch() {
    $("#SalesInvoiceAdvanceSearch").modal("show");
    setTimeout(function () {
      (<any>$("#id_ddlFinancialyear")).selectpicker("refresh");
    }, 100);
  }

  GetBillListByCompany() {
    $("#SelectBillList").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetBillListByCompany",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: BillsComponent.bc.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Enter Bill No",
    });
  }

  GetCustomerVendorSelect2Data() {
    $("#CompanyData").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetVendorName",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: BillsComponent.bc.TenantId,
            Type: "Bills",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Enter Vendor Name",
    });
  }

  GetContainerList() {
    $("#SelectContainerList").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Sales/GetContainerListByCompany",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: BillsComponent.bc.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Enter Container No",
    });
  }

  GetTripNoList() {
    $("#SelectTripNo").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Sales/GetTripNoListByCompany",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: BillsComponent.bc.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data, params) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Enter Trip No",
    });
  }

  GetAccountingYear() {
    this._appService.Get("Common", "GetAccountingYear").subscribe(
      (response) => {
        this.FinancialYearArray = response;

        setTimeout(() => {
          (<any>$("#id_ddlFinancialyear")).selectpicker("refresh");
          // this.GetBillsList();
        }, 1000);
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Vahicle type data !",
          "error"
        );
      }
    );
  }

  AdvanceSearch() {
    var BillId: any;
    var VendorId: any;
    var tripId: any;
    var containerNo: any;
    var fromDate: any;
    var toDate: any;
    var Financialyear: any;
    BillId =
      $("#SelectBillList").val().join(",") == ""
        ? null
        : $("#SelectBillList").val().join(",");
    VendorId =
      $("#CompanyData").val().join(",") == ""
        ? null
        : $("#CompanyData").val().join(",");
    tripId =
      $("#SelectTripNo").val().join(",") == ""
        ? null
        : $("#SelectTripNo").val().join(",");
    containerNo =
      $("#SelectContainerList").val().join(",") == ""
        ? null
        : $("#SelectContainerList").val().join(",");
    fromDate =
      this.GetFormattedDate("InvoiceFromDate", $("#InvoiceFromDate").val()) ==
        ""
        ? null
        : this.GetFormattedDate("InvoiceFromDate", $("#InvoiceFromDate").val());
    toDate =
      this.GetFormattedDate("InvoiceToDate", $("#InvoiceToDate").val()) == ""
        ? null
        : this.GetFormattedDate("InvoiceToDate", $("#InvoiceToDate").val());
    Financialyear =
      $("#id_ddlFinancialyear").val() == ""
        ? null
        : $("#id_ddlFinancialyear").val();

    if (
      BillId == null &&
      VendorId == null &&
      tripId == null &&
      containerNo == null &&
      fromDate == null &&
      toDate == null &&
      Financialyear == null
    ) {
      this.toastr.error("Please apply any filter  !", "error");
    } else {
      if (this.datatableBills) {
        this.selectedCard = "All";
        this.datatableBills.destroy();
        this.GetBillsList();
      }
      $("#SalesInvoiceAdvanceSearch").modal("hide");
    }
  }

  clearAdvanceSearch() {
    $("#SelectBillList").val("");
    $("#CompanyData").val("");
    $("#SelectTripNo").val("");
    $("#SelectContainerList").val("");
    $("#InvoiceFromDate").val("").datepicker("update");
    $("#InvoiceToDate").val("").datepicker("update");
    $("#id_ddlFinancialyear").val("");
    $("#SalesInvoiceAdvanceSearch").modal("hide");
    if (this.datatableBills) {
      this.selectedCard = "All";
      this.datatableBills.destroy();
      this.GetBillsList();
    }
  }

  RefreshvalidDateModal() {
    setTimeout(() => {
      $(".datepicker3").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd-M-yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);
  }
  //end

  //added by vithujan 06-02-2023
  onShowShortcut() {
    $("#ShortcutKeys").modal("show");
    BillsComponent.bc.TransactionType = "Bills";

    if (BillsComponent.bc.showbill == false) {
      BillsComponent.bc.ModalType = "A";
    } else {
      BillsComponent.bc.ModalType = "B";
    }
  }

  showHelpMenu() {
    document.addEventListener("keydown", function (zEvent) {
      if (zEvent.altKey && zEvent.key === "d") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("Draft");
        }
      }
      if (zEvent.altKey && zEvent.key === "z") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("Authorized");
        }
      }
      if (zEvent.altKey && zEvent.key === "p") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("Posted");
        }
      }
      if (zEvent.altKey && zEvent.key === "u") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("Pending Payments");
        }
      }
      if (zEvent.altKey && zEvent.key === "x") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("Paid");
        } else {
          zEvent.preventDefault();
          BillsComponent.bc.DeletePurchaseBill(BillsComponent.bc.Bills.Id);
        }
      }
      //added by maaria
      if (zEvent.altKey && zEvent.key === "t") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("Deleted");
        }
      }
      //end
      if (zEvent.altKey && zEvent.key === "a") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.SearchStatus("All");
        } else {
          zEvent.preventDefault();
          BillsComponent.bc.AuthorizeBill();
        }
      }
      if (zEvent.altKey && zEvent.key === "n") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.NewBill();
        } else {
          zEvent.preventDefault();
          BillsComponent.bc.AddCharge();
        }
      }
      if (zEvent.altKey && zEvent.key === "i") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.ShowPendingIssueBillList();
        }
      }
      if (zEvent.altKey && zEvent.key === "s") {
        if (BillsComponent.bc.showbill == true) {
          zEvent.preventDefault();
          BillsComponent.bc.SaveBills();
        }
      }
      if (zEvent.altKey && zEvent.key === "o") {
        if (BillsComponent.bc.showbill == true) {
          zEvent.preventDefault();
          BillsComponent.bc.PostPurchaseBill();
        }
      }
      if (zEvent.key === "F1") {
        zEvent.preventDefault();
        BillsComponent.bc.onShowShortcut();
      }
      if (zEvent.key === "F2") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.clearAdvanceSearch();
        }
      }
      if (zEvent.key === "F5") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.showAdvanceSearch();
        }
      }
      if (zEvent.key === "F8") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          document.getElementById("BillSearch").focus();
        }
      }
      if (zEvent.key === "F12") {
        if (
          BillsComponent.bc.showbill == true &&
          BillsComponent.bc.ShowAttachment == true
        ) {
          zEvent.preventDefault();
          $("#BillsAttchment").modal("show");
        }
      }
      if (zEvent.key === "ArrowDown") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();

          if (BillsComponent.bc.rowIndex < -1) {
            BillsComponent.bc.rowIndex = -1;
          }
          BillsComponent.bc.rowIndex = BillsComponent.bc.rowIndex + 1;
          if (BillsComponent.bc.rowIndex >= BillsComponent.bc.totalRowsCount) {
            BillsComponent.bc.rowIndex = BillsComponent.bc.totalRowsCount - 1;
          }

          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex)
            .removeClass("m-datatable__row--even");
          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex - 1)
            .addClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex)
            .removeClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex)
            .addClass("highlight");
          window.scrollBy(0, 50);
        }
      }
      if (zEvent.key === "ArrowUp") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          BillsComponent.bc.rowIndex = BillsComponent.bc.rowIndex - 1;
          if (BillsComponent.bc.rowIndex <= 0) BillsComponent.bc.rowIndex = 0;

          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex)
            .removeClass("m-datatable__row--even");
          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex + 1)
            .addClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex)
            .removeClass("default-color");
          $(".m-datatable__table > tbody > tr")
            .eq(BillsComponent.bc.rowIndex)
            .addClass("highlight");
          window.scrollBy(0, -100);
        }
      }
      if (zEvent.key === "Enter") {
        if (BillsComponent.bc.showbill == false) {
          zEvent.preventDefault();
          var rows = BillsComponent.bc.datatableBills;
          rows.rows(".m-datatable__row");
          if (rows.nodes().length > 0) {
            $.each(rows.nodes(), function (i) {
              var keys = Object.keys(rows.nodes()[i]);
              var FileList: any = {};
              FileList = rows.nodes()[i][keys[0]].obj;
              if (i == BillsComponent.bc.rowIndex) {
                BillsComponent.bc.GetBillById(FileList.Id);
              }
            });
          }
        }
      }
      if (zEvent.key === "Escape") {
        if (BillsComponent.bc.showbill == true) {
          if (document.body.className.indexOf("modal-open") !== -1) {
          } else {
            zEvent.preventDefault();
            BillsComponent.bc.onBack();
            setTimeout(() => {
              var rows = BillsComponent.bc.datatableBills;
              rows.rows(".m-datatable__row");
              BillsComponent.bc.totalRowsCount = rows.nodes().length;
            }, 2000);
            BillsComponent.bc.rowIndex = -1;
          }
        }
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "p") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/PendingConsignments");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "s") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/SalesInvoice");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "r") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/PaymentReceived/list");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "j") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/CashReceipt");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "l") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/PendingBills");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "b") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/Bills");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "e") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/Expense");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "q") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/PaymentRequest");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "m") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/PaymentMade/list");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "h") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/SchedulePayment");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "i") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/ByVehicle");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "w") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/network/list");
      }
      if (zEvent.altKey && zEvent.ctrlKey && zEvent.key === "a") {
        zEvent.preventDefault();
        BillsComponent.bc.router.navigateByUrl("/BankAccounts");
      }
    });
  }
  //end

  //added by vithujan 13-03-2023
  refreshDropDownName() {
    setTimeout(function () {
      (<any>$("#type")).selectpicker("refresh");
      (<any>$("#method")).selectpicker("refresh");
      (<any>$("#transportservice")).selectpicker("refresh");
      (<any>$("#IntraState")).selectpicker("refresh");
      (<any>$("#OutsideState")).selectpicker("refresh");
      (<any>$("#m_form_status")).selectpicker("refresh");
    }, 200);
  }

  GetSelectData() {
    $("#ChargeAccountsType").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url:
          environment.apiUrl + "api/ChartsofAccount/GetAccountListforCharges",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 20 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Enter Account",
    });

    $("#TripExpenseCharge").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Charge/getTripExpenseCharge",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            param1: params.term,
            param2: BillsComponent.bc.CompanyId,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Expense Charge",
    });
  }

  GetChargeType() {
    this._appService
      .GetById("Charge", "GetChargeType", this.TenantId)
      .subscribe((response) => {
        this.GetChargeTypeList = response;
        this.refreshDropDownName();
      });
  }

  GetTransportService() {
    this._appService
      .GetById("Charge", "GetTransportMethod", this.TenantId)
      .subscribe((response) => {
        this.GetTransportMethodList = response;
        this.refreshDropDownName();
      });
  }

  GetGSTTaxGroup() {
    this._appService.Get("Charge", "GetGSTGroupList").subscribe((response) => {
      this.IntraState = response;
      this.OutSideyourState = response;
      this.refreshDropDownName();
    });
  }

  NewCharge() {
    this.model = {};
    this.model.IsActive = true;
    this.model.IsGSTApplicable = true;
    this.model.IsFuelAccount = false;
    this.model.isDefaultCharge = false;
    this.model.IntraStateId = null;
    this.model.OutsideStateId = null;
    this.refreshDropDownName();
    this.ClearValidationsCharge();
    this.AccountData.Id = null;

    $("#newCharge").modal("show");
    if (
      BillsComponent.bc.commonService.CheckHasRight("ADD", "CHARGE_DETAILS")
    ) {
      $("#chargeSave").css("display", "inline-block");
    } else {
      $("#chargeSave").css("display", "none");
    }

    if ($("#ChargeAccountsType").select2()) {
      $("#ChargeAccountsType").val("");
      $("#ChargeAccountsType").select2("destroy");
    }
    if ($("#TripExpenseCharge").select2()) {
      $("#TripExpenseCharge").val("");
      $("#TripExpenseCharge").select2("destroy");
    }
    this.GetSelectData();
    this.GetChargeType();
    this.GetTransportService();
    this.GetGSTTaxGroup();
  }

  ValidateCharge = function () {
    var flag = true;
    if (
      !BillsComponent.bc.commonService.ValidateRequiredField(
        $("#ChargeCode"),
        "Enter Charge Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !BillsComponent.bc.commonService.ValidateRequiredField(
        $("#chargeName"),
        "Please Enter Data",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !BillsComponent.bc.commonService.ValidateRequiredField2(
        $("#type"),
        $("#FieldSetChargeType"),
        "Please Select Option",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !BillsComponent.bc.commonService.ValidateRequiredField2(
        $("#transportservice"),
        $("#FieldSetTranspoterService"),
        "Please Select Option",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (this.model.IsGSTApplicable) {
      if (
        !BillsComponent.bc.commonService.ValidateRequiredField2(
          $("#IntraState"),
          $("#FieldSetIntraState"),
          "Please Select IntraState",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !BillsComponent.bc.commonService.ValidateRequiredField2(
          $("#OutsideState"),
          $("#FieldSetOutsideState"),
          "Please Select OutsideState",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    } else {
      BillsComponent.bc.commonService.ClearMessage($("#FieldSetIntraState"));
      BillsComponent.bc.commonService.ClearMessage($("#FieldSetOutsideState"));
    }
    if (
      !BillsComponent.bc.commonService.ValidateRequiredField2(
        $("#ChargeAccountsType"),
        $("#FieldSetChargeAccountsType"),
        "Please Select Account",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  };

  ClearValidationsCharge = function () {
    BillsComponent.bc.commonService.ClearMessage($("#ChargeCode"));
    BillsComponent.bc.commonService.ClearMessage($("#chargeName"));
    BillsComponent.bc.commonService.ClearMessage($("#FieldSetChargeType"));
    BillsComponent.bc.commonService.ClearMessage(
      $("#FieldSetTranspoterService")
    );
    BillsComponent.bc.commonService.ClearMessage($("#FieldSetIntraState"));
    BillsComponent.bc.commonService.ClearMessage($("#FieldSetOutsideState"));
    BillsComponent.bc.commonService.ClearMessage($("#ChargeAccountsType"));
    BillsComponent.bc.commonService.ClearMessage(
      $("#FieldSetChargeAccountsType")
    );
    BillsComponent.bc.commonService.ClearMessage($("#TripExpenseCharge"));
    BillsComponent.bc.commonService.ClearMessage(
      $("#FieldSetTripExpenseCharge")
    );
  };

  SaveChargeData() {
    this.model.TripExpenseCharge = $("#TripExpenseCharge").val();
    this._appService.Post("Charge", "SaveChargedData", this.model).subscribe(
      (response) => {
        $("#newCharge").modal("hide");
        this.ValidateCharge();
        this.ClearValidationsCharge();
        this.toastr.success("Save Successfully ", "Charges");
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  SaveData() {
    this.AccountData.Name = $("#chargeName").val();
    this.AccountData.ParentId = $("#ChargeAccountsType").val();
    this.AccountData.IsAuthorized = true;
    this.AccountData.IsActive = true;
    this.AccountData.AccountType = 2;
    this.AccountData.PrintingSequence = $("#PrintingSequence").val();
    this.AccountData.CompanyId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).Id;
    this.AccountData.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    if (this.AccountData.ParentId != "") {
      this._appService
        .GetByThreeId(
          "ChartsofAccount",
          "CheckAccountExist",
          this.AccountData.Id,
          this.AccountData.Name,
          this.AccountData.ParentId
        )
        .subscribe(
          (response) => {
            this._appService
              .Post("ChartsofAccount", "SaveAccount", this.AccountData)
              .subscribe(
                (response) => {
                  this.model.AccountTypeId = $("#ChargeAccountsType").val();
                  this.model.AccountId = response.Id;
                  this.SaveChargeData();
                },
                (err) => {
                  this.toastr.error(
                    "Error occurred while saving data !",
                    "error"
                  );
                }
              );
          },
          (err) => {
            this.SaveChargeData();
          }
        );
    } else {
      this.SaveChargeData();
    }
  }

  chargesPost() {
    if (!this.ValidateCharge()) {
      return false;
    }
    this.model.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    var lstTransport = [];
    for (let index = 0; index < this.model.TransportService.length; index++) {
      lstTransport.push({
        TransportNames: this.model.TransportService[index],
      });
    }
    this.model.TransportService = lstTransport;
    this.SaveData();

    //$("#newCharge").modal('hide');
  }

  onCloseChargeModel() {
    this.model = {};
    $("#newCharge").modal("hide");
    this.ClearValidationsCharge();
  }
  //end

  openNetworkModel() {
    this.isShowOtherModel = "NetwrokModel";
    this.ChildNetworkComponent.OnNewNetworkClick("false");
  }

  NetworkModelClose() {
    this.isShowOtherModel = "NO";
  }

  DirectPostBillList() {
    Helpers.setLoading(true);
    this.postBillListData = [];
    var rows = this.datatableBills;
    rows.rows(".m-datatable__row--active");
    if (rows.nodes().length > 0) {
      $.each(rows.nodes(), function (i) {
        var keys = Object.keys(rows.nodes()[i]);
        var BillList: any = {};
        BillList = rows.nodes()[i][keys[0]].obj;
        var objV: any = {};
        objV.Id = BillList.Id;
        objV.BillNo = BillList.BillNo;
        objV.BillStatus = BillList.billStatus;
        objV.CompanyId = BillsComponent.bc.CompanyId;
        objV.UserId = BillsComponent.bc.UserId;
        BillsComponent.bc.postBillListData.push(objV);
      });
    } else {
      this.toastr.error("Please select bill  !", "error");
      Helpers.setLoading(false);
      return false;
    }
    setTimeout(() => {
      console.log("this.postBillListData", this.postBillListData);
      this._appService
        .Post("Bills", "bill_DirectPostBillList", this.postBillListData)
        .subscribe(
          (response) => {
            var resObj: any = [];
            resObj = response;
            var messageStr = "";
            resObj.forEach((element) => {
              messageStr =
                messageStr + element.BillNo + " - " + element.IsDone + " <br>";
            });
            swal(messageStr);
            this.datatableBills.destroy();
            this.GetBillsList();
            Helpers.setLoading(false);
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
            Helpers.setLoading(false);
          }
        );
    }, 300);
  }

  //added by vithujan 02-06-2023
  AutoSetOffAdvance() {
    for (let index = 0; index < this.AdvancePaymentDetailList.length; index++) {
      var data = this.ChargesList.filter(
        (x) => x.THCName === this.AdvancePaymentDetailList[index].THC
      );

      var totalAdvance = 0;
      if (data.length > 0) {
        data.forEach((element) => {
          totalAdvance = totalAdvance + element.Amount;
          if (this.Bills.NetTotal >= totalAdvance) {
            if (
              this.AdvancePaymentDetailList[index].BalanceAdvance <=
              this.Bills.NetTotal
            ) {
              this.AdvancePaymentDetailList[index].PaidAmount =
                this.AdvancePaymentDetailList[index].BalanceAdvance;
            } else {
              this.AdvancePaymentDetailList[index].PaidAmount = 0;
            }
          }
        });
      }
    }

    this.DraftPaymentDetail();
  }

  GetTDSListForCharge() {
    this._appService
      .Get("Charge", "ch_GetTDSListForCharge")
      .subscribe((response) => {
        this.chargeWiseTDSMasterList = response;
        setTimeout(function () {
          (<any>$("#se_bh_chTDS")).selectpicker("refresh");
        }, 200);
      });
  }

  //added by vithujan 22-07-2023
  DeleteJournalEntry() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      if (e.value == true) {
        BillsComponent.bc._appService
          .Delete(
            "JournalEntry",
            "DeleteJournalEntryById",
            BillsComponent.bc.Bills.Id
          )
          .subscribe(
            (response) => {
              BillsComponent.bc.toastr.success(
                "Data Deleted Successfully !",
                "Success"
              );
              BillsComponent.bc.GetJVSummaryData();
              BillsComponent.bc.GetBillById(BillsComponent.bc.Bills.Id);
            },
            (err) => {
              BillsComponent.bc.toastr.error(
                err._body.replace(/"/g, ""),
                "error"
              );
              // JournalEntryComponent.journalEntryComponent.toastr.error("Error in deleting data !","error");
            }
          );
      }
    });
  }

  GetPrintBillData(Id, Type, ToDo) {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId("Bills", "bill_GetPrintBillData", Id, Type)
      .subscribe(
        (response) => {
          this.PrintBillData = response;
          this.PrintBillData[0].BillDetailDataArray = [];
          let resObj: any = [];
          if (
            this.PrintBillData[0].BillDetailData != null &&
            this.PrintBillData[0].BillDetailData != ""
          ) {
            resObj = JSON.parse(this.PrintBillData[0].BillDetailData);
          }
          this.PrintBillData[0].BillDetailDataArray = resObj;
          //add by maaria on 20-10-2023
          if (this.PrintBillData[0].isDebit) {
            this.PrintBillData[0].BillDetailDataArray.forEach((item) => {
              item.Rate = item.Rate < 0 ? -item.Rate : item.Rate;
              item.Discount =
                item.Discount < 0 ? -item.Discount : item.Discount;
              item.Amount = item.Amount < 0 ? -item.Amount : item.Amount;
            });
          }
          //end
          if (ToDo == "Print") {
            if (Type == "Detail") {
              this.PrintDetailBill();
            }
          }
          Helpers.setLoading(true);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          Helpers.setLoading(false);
        }
      );
  }

  PrintDetailBill() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetailBill");
      var $iframe = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 200);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#se_PrintBill").val("");
      Helpers.setLoading(false);
    }, 100);
  }

  OnDownloadClick(Id, Type, ToDo) { }

  //added by maaria
  UnDeleteBill() {
    Helpers.setLoading(true);
    $("#btnUnDeleteForBill").prop("disabled", true);
    this._appService
      .GetByTwoId("Bills", "IN_UnDeleteBills", this.Bills.Id, this.UserId)
      .subscribe(
        (response) => {
          $("#BtnInvoiceUnDelete").prop("disabled", false);
          this.selectedCard = "Draft";
          //this.GoBack();
          //this.showbill = false;
          this.showbill = true;
          this.GetBillById(this.Bills.Id);
          const Saved = this.translate.instant(
            "BILLSCOMP.BillUnDeleteSuccessfully"
          );
          this.toastr.success(Saved, "Success");
          Helpers.setLoading(false);
        },
        (err) => {
          $("#btnUnDeleteForBill").prop("disabled", false);
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  //end

  // getBillList(){

  //   this._appService
  //     .GetBill("Bills", "GetBillStatusCount", this.CompanyId)
  //     .subscribe(
  //       (response) => {
  //         this.DashboardData.DraftCount = response[0].DraftCount;
  //         this.DashboardData.AuthorizedCount = response[0].AuthorizedCount;
  //         this.DashboardData.PostedCount = response[0].PostedCount;
  //         this.DashboardData.PendingPaymentsCount =
  //           response[0].PendingPaymentsCount;
  //         this.DashboardData.PaidCount = response[0].PaidCount;
  //         this.DashboardData.AllCount = response[0].AllCount;
  //       },
  //       (err) => { }
  //     );

  // }
  // getTotalAmount() {
  //   return this.transactions.map(t => t.cost).reduce((acc, value) => acc + value, 0);
  // }

  // added by vithujan 19-10-2023 - Siddarth
  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = "Bills";
    obj.UserId = this.UserId;

    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe(
      (response) => { },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  //added by vithujan 08-02-2024 - Siddarth
  GetSelectBillNo() {
    $(".BillNoSelect").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Common/GetBillNoSelect2",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            CompanyId: BillsComponent.bc.CompanyId,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Enter Bill No",
    });
    $(".BillNoSelect").on("select2:select", function (e) {
      var data = e.params.data;
      BillsComponent.bc.Bills.BillRefStatus = data.Status;
    });
  }
  // added by rahul
  isDisabled: boolean = false;
  get_IsCompanyDisable(Id) {

    this._appService.GetByOneParam('Sales', 'get_IsCompanyDisable', Id).subscribe(
      (response) => {
        console.log(response, 'get_IsCompanyDisable');
        if (response[0].IsActive == false || null) {
          this.isDisabled = true;
          this.toastr.error("Selected Driver is disabled, you are not allowed to generate Bill", 'Error')
        }
        else if (response[0].IsDisable == true) {
          this.isDisabled = true;
          this.toastr.error("Selected customer is disabled, you are not allowed to generate Bill", 'Error')
        }
        else {
          this.isDisabled = false
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error")
      }
    )
  }
  //end 

  // added by vithujan 20-06-2024
  pushToERPAPI() {
    var data: any = [];
    var erp_data: any = {};
    this.Bills.BillsDetails.forEach(element => {
      var obj: any = {};
      obj.VENDOR = this.Bills.VendorCode;
      obj.DOCUMENT_DATE = this.Bills.ReferenceDate == null || "" ? this.datePipe.transform(this.Bills.BillDate, 'yyyyMMdd') : this.datePipe.transform(this.Bills.ReferenceDate, 'yyyyMMdd');
      obj.REFERENCE = this.Bills.ReferenceNo == null || "" ? this.Bills.BillNo : this.Bills.ReferenceNo;
      obj.POSTING_DATE = this.Bills.ReferenceDate == null || "" ? this.datePipe.transform(this.Bills.BillDate, 'yyyyMMdd') : this.datePipe.transform(this.Bills.ReferenceDate, 'yyyyMMdd');
      obj.AMOUNT = this.Bills.NetTotal;
      obj.CURRENCY = 'INR';
      obj.TAX_CODE = "";
      obj.GST_PARTNER = "";
      obj.BUSINESS_PLACE = this.Bills.BusinessPlace;
      obj.SECTION_CODE = "";
      obj.HEADER_TEXT = "";
      obj.BASELINE_DATE = "";
      obj.PAYMENT_TERM = this.Bills.PaymentTerms;
      obj.WITHHOLDING_TEXT = element.TDSAmount;
      obj.GL_ACCOUNT = element.ChargeName;
      obj.GL_AMOUNT = element.Amount;
      obj.ASSIGNMENT = "";
      obj.LINE_ITEM_TEXT = "";
      obj.BUSINESS_AREA = "";
      obj.COST_CENTER = "";
      obj.ORDER_NUMBER = "";
      obj.PROFIT_CENTER = "";
      obj.HSN = element.HSNNo;

      data.push(obj);
    });

    erp_data.item = data;
    erp_data.UserId = this.UserId;
    erp_data.BillId = this.Bills.Id;
    this._appService
      .Post("Bills", "PushToERP", erp_data)
      .subscribe(
        (response) => {
          if (response == 'record inserted sucessfully') {
            this.toastr.success(response, 'Ok');
            this.IsPushedtoERP = true;
          } else {
            this.toastr.error(response, 'Error');
          }
        },
        (err) => {
          this.toastr.error('Error Occured while process data!', 'Error');
        }
      );
  }

  GetExpensebytrip() {

    if (

      !this.commonService.ValidateRequiredField2(

        $("#THC"),

        $("#THC"),

        "Please Select Consigment No",

        "after",

        ""

      )

    ) {

      return
    }
    this.Expensebytrip = []
    this._appService.GetByOneParam('Sales', 'GetExpensebyCN', this.ConsignmentId).subscribe(
      (response) => {

        this.Expensebytrip = response;
        // console.log(this.Expensebytrip, 'GetExpensebyCN');
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error")
      }
    )

  }

  // CheckChargecode (THC , ChargeName){
  //   this._appService.GetByTwoId('Sales', 'Checkchargefortrip', THC , ChargeName).subscribe(
  //     (response) => {

  //       this.Checkchargefortrip = response;

  //       // console.log(this.Expensebytrip, 'GetExpensebyCN');
  //     },
  //     (err) => {
  //       this.toastr.error(err._body.replace(/"/g, ""), "Error");
  //     }
  //   )
  // }

}
